import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company, // ดึง company context ถ้ามี
  loading,
  NavbarAdmin,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  Select,
  Modal,
  toFixed,
  t,
  format_date,
  DatePicker,
  searchCustomerRows,
  mergeCustomerPins,
  addCustomerPin,
  ActionIconButton,
  ACTION_ICONS,
  STICKY_ACTION_STYLE,
  fmtInt,
} from "../../components/CustomComponent.js";
import { GoogleMap, Marker } from "@react-google-maps/api";
import MapsLoader from "../../components/maps/MapsLoader";
import PROVINCE from "../../assets/files/th_province.json";
import { pickFilesByRule, compressImageFiles, toMB, formatText } from "../../utils/fileUpload";
import { addDaysToDate, calcWarrantyExpireDate, calcWarrantyMonthDiff } from "../../utils/warranty";
import { data } from "react-router";

// Tooltip แบบเดียวกับช่อง "ค่าเดินทาง (฿)" ในหน้าใบงาน — hover หรือคลิกไอคอน (i)
// แล้วเปิดการ์ดลอยเหนือไอคอน (position: fixed จับพิกัดจาก getBoundingClientRect ตอนเปิด
// เพราะไอคอนอยู่ใน modal ที่ scroll ได้ การ์ดจึงต้องอ้างอิงพิกัดบนจอ ไม่ใช่ตำแหน่งใน DOM)
// ตัดชื่อไฟล์/mime ให้ไม่เกินความยาวคอลัมน์ใน DB (file_name 255, mime_type 150) โดยคงนามสกุลไว้
const ATTACH_FILE_NAME_MAX = 255;
const ATTACH_MIME_MAX = 150;
const limitFileName = (name, max = ATTACH_FILE_NAME_MAX) => {
  if (!name) return null;
  const str = String(name);
  if (str.length <= max) return str;
  const dot = str.lastIndexOf(".");
  const ext = dot > 0 && str.length - dot <= 20 ? str.slice(dot) : "";
  return str.slice(0, max - ext.length) + ext;
};
const limitMime = (mime) => (mime ? String(mime).slice(0, ATTACH_MIME_MAX) : null);

class InfoTooltip extends Component {
  state = { open: false, rect: null };

  openTooltip = (e) => this.setState({ open: true, rect: e.currentTarget.getBoundingClientRect() });

  closeTooltip = () => this.setState({ open: false, rect: null });

  toggleTooltip = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState((state) => ({ open: !state.open, rect: state.open ? null : rect }));
  };

  render() {
    const { open, rect } = this.state;

    return (
      <span
        style={{ position: "relative", display: "inline-block", marginLeft: "5px", cursor: "pointer" }}
        onMouseEnter={this.openTooltip}
        onMouseLeave={this.closeTooltip}
        onClick={this.toggleTooltip}
      >
        <span className="icon text-secondary" style={{ fontSize: "12px" }}>{"\uf05a"}</span>
        {open && (
          <div
            style={{
              position: "fixed",
              bottom: rect ? `${window.innerHeight - rect.top + 6}px` : "50%",
              left: rect ? `${rect.left + rect.width / 2}px` : "50%",
              transform: "translateX(-50%)",
              background: "#fff",
              border: "1px solid #dee2e6",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              padding: "10px 14px",
              zIndex: 9999,
              width: this.props.width || "max-content",
              maxWidth: "min(300px, calc(100vw - 24px))",
              textAlign: "left",
              fontSize: "12px",
              fontWeight: "normal",
              color: "#333",
              whiteSpace: "normal",
            }}
          >
            {this.props.title && <div className="fw-bold text-dark mb-2">{this.props.title}</div>}
            <div className="text-secondary">{this.props.children}</div>
          </div>
        )}
      </span>
    );
  }
}

// จำนวนหลักของเลขรันท้าย Serial No.
const SERIAL_RUNNING_DIGITS = 3;

// ตัวเลือกของฟอร์มขึ้นทะเบียน FMN-03 (ป้ายชื่ออยู่ในไฟล์ภาษา key reg_*)
// ช่อง "ระบบ" มาจาก master จัดกลุ่มเครื่องจักร (ตั้งค่าระบบ)
// ช่อง "ชื่อผู้ผลิต/ยี่ห้อ" มาจาก master ยี่ห้อ (table brands) และ "ชนิด/รุ่น" มาจาก master รุ่น (table models) ของยี่ห้อที่เลือก
// GUSCO ไม่ใช้ซีรีส์ (table series) ในฟอร์มนี้ — เก็บลง assets เป็นชื่อ (brand_name / model_name) เหมือนเดิม
const REG_MACHINE_STATUSES = ["new", "relocated", "existing"];
// สถานะขึ้นทะเบียน (assets.registration_status) -> สี + ป้าย ; approved ใช้ is_active แสดงเปิด/ปิดใช้งานแทน
const REG_STATUS_BADGES = {
  draft: { color: "secondary", label: "draft" },
  pending: { color: "warning", label: "waiting_approval" },
  revise: { color: "danger", label: "reg_kpi_revise" },
};
const regStatusBadge = (item) =>
  REG_STATUS_BADGES[item?.registration_status] ||
  (item?.is_active ? { color: "success", label: "active" } : { color: "secondary", label: "inactive" });
const REG_DOCUMENT_KEYS = [
  "general_manual", "electrical_manual", "mechanical_manual", "control_manual", "spare_part_drawing",
  "structure_drawing", "electrical_drawing", "mechanical_drawing", "spare_part_list",
];
const REG_INSPECTION_KEYS = ["inspection_report", "adjustment_report"];
const REG_TRAINING_COURSES = ["safety", "maintenance", "operation"];
const REG_TRAINING_LEVELS = ["basic", "advance", "apply"];
const REG_APPROVER_ROLES = ["engineer", "manager", "site"];
// ช่องบังคับ (*) ของฟอร์มขึ้นทะเบียน เรียงตามลำดับบนหน้าจอ: key = ต่อท้าย DOM id "reg-field-", label = key ของคำแปล
const REG_REQUIRED_FIELDS = [
  { key: "department", step: 1, label: "reg_owner_department" },
  { key: "received_date", step: 1, label: "received_date" },
  { key: "machine_name", step: 1, label: "reg_machine_name" },
  { key: "system", step: 1, label: "system" },
  { key: "brand", step: 2, label: "reg_brand" },
  { key: "model", step: 2, label: "reg_model" },
];
// รูปในฟอร์มขึ้นทะเบียน: ไม่จำกัดจำนวน แต่ละรูปไม่เกิน 10 MB (ขนาดก่อนย่อ)
// ความคลาดเคลื่อนของ GPS ที่เกินค่านี้ (เมตร) ถือว่าความแม่นยำต่ำ
const REG_GPS_LOW_ACCURACY_METERS = 50;
const REG_PHOTO_RULES = { image: { maxFiles: Infinity, maxSize: 10 * 1024 * 1024 } };

export default class AssetManagement extends Component {
  isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  constructor(props) {
    super(props);
    this.state = {
      // Filters
      filter_search: "",
      filter_customer: "",
      filter_department: "",
      filter_category: "",
      filter_status: "",
      filter_vendor_warranty: "",

      // Data
      data: [],
      data_customer: [],
      customer_pins: [], // ลูกค้าที่ถูกอ้างถึงอยู่ ต้องคงไว้ในรายการแม้ผลค้นหาจะเปลี่ยน
      data_finance: [],
      data_sale: [],
      data_part: [],
      data_project: [],
      data_department: [],
      data_cwc: [],
      data_machine_group: [],
      data_brand: [],
      count: 0,
      // KPI card ด้านบน — นับจากทุกแถวที่ตรง filter (backend summary=true) ไม่ใช่เฉพาะหน้าปัจจุบัน
      summary_count: { total: 0, active: 0, draft: 0, pending: 0, revise: 0, customer_warranty_expired: 0 },

      // Modal State
      modal_create: false,
      modal_map: false,
      modal_create_closing: false,

      // --- Form Fields (Mapped to API Payload) ---
      uid: "",
      company_id: company?.id || "446a2297-d012-43a1-af6c-eda4055099cf", // ใส่ default ตาม curl
      project_id: "",
      department_id: "",
      asset_code: "",
      sequence: 1,
      customer_id: "",
      finance_id: "",
      sale_id: "",
      part_id: "", // Item ID
      serial_number: "",
      price: "",
      
      // Location
      location_running_number: "",
      location_name: "",
      location_address: "",
      location_province: "",
      location_district: "",
      location_sub_district: "",
      location_zip_code: "",
      location_floor_room: "",
      latitude: "",
      longitude: "",
      location_remark: "",
      
      // Contact
      contract_name: "",
      contract_phone: "",
      contract_email: "",
      
      // Invoice
      invoice_number: "",
      invoice_date: "",
      coi_date: "",

      // Filter Information (ข้อมูลไส้กรอง) - รอบการเปลี่ยนอะไหล่ หน่วยเป็นเดือน
      replacement_period: "",

      
      // Warranty
      customer_warranty: [{ customer_warranty_month: "", customer_warranty_expire_date: "", customer_warranty_renew_date: "", customer_warranty_renew_remark: "" }],
      customer_warranty_count: 0,
      customer_warranty_remark: "",
      
      company_warranty: [{ company_warranty_month: "", company_warranty_expire_date: "", company_warranty_renew_date: "", company_warranty_renew_remark: "" }],
      company_warranty_count: 0,
      company_warranty_remark: "",
      
      tag_name: "",
      tags: [],
      is_active: true,
      registration_status: "draft",

      selected_cwc: "",
      cwc_attachments: [],

      ...this.getRegistrationFormDefaults(),

      currentPath: null
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  componentWillUnmount() {
    if (this.modalCloseTimer) {
      clearTimeout(this.modalCloseTimer);
    }
  }

  // --- API Functions ---

  toCustomerOption = (customer) => ({
    ...customer,
    value: customer.uid,
    label: (customer.customer_code || "") + " " + (customer.full_name_th || customer.name || ""),
  });

  // ค้นหาลูกค้าฝั่ง server (Select เรียกให้ตอนพิมพ์) - token กันผลลัพธ์ที่ตอบช้ามาทับคำค้นล่าสุด
  customerSearchToken = 0;

  searchCustomers = async (keyword = "") => {
    const token = ++this.customerSearchToken;
    const rows = await searchCustomerRows(keyword);
    if (token !== this.customerSearchToken || rows === null) return;

    this.setState((prevState) => ({
      data_customer: mergeCustomerPins(rows.map(this.toCustomerOption), prevState.customer_pins),
    }));
  };

  // ลูกค้าของแถวที่กำลังเปิดดู/แก้ไข ต้องอยู่ใน data_customer เสมอ เพราะหน้านี้อ่านชื่อลูกค้าจาก options ด้วย find()
  pinCustomer = (customer) => {
    const option = customer?.uid ? this.toCustomerOption(customer) : customer;
    if (!option?.value) return;

    this.setState((prevState) => {
      const customer_pins = addCustomerPin(prevState.customer_pins, option);
      return { customer_pins, data_customer: mergeCustomerPins(prevState.data_customer, customer_pins) };
    });
  };

  // สถานที่ติดตั้งใช้ที่อยู่ของลูกค้าเป็นค่าเริ่มต้น (ผู้ใช้แก้ไขเองได้ และไม่บังคับกรอก)
  // ใช้เฉพาะตอนสร้างใหม่ ไม่ทับที่อยู่ของรายการที่บันทึกไปแล้ว
  applyCustomerLocationDefaults = (customer) => {
    // customer.uid ว่าง = ผู้ใช้กดล้างตัวเลือกลูกค้า ไม่ต้องไปล้างที่อยู่ที่กรอกไว้
    if (this.state.uid || !customer?.uid) return;

    // จังหวัด/อำเภอ/ตำบล ฝั่งลูกค้าเป็น free text ต้องจับคู่กับ th_province.json ให้ได้ก่อน
    // ไม่งั้น Select จะหา option ไม่เจอแล้วแสดงเป็นค่าว่าง
    const province = PROVINCE.find((e) => e.th === (customer.province || "").trim());
    const district = province?.district?.find((e) => e.th === (customer.district || "").trim());
    const sub_district = district?.sub_district?.find((e) => e.th === (customer.sub_district || "").trim());
    const zip_code = sub_district?.code ?? customer.zip_code;

    this.setState({
      location_address: customer.address || "",
      location_province: province?.th || "",
      location_district: district?.th || "",
      location_sub_district: sub_district?.th || "",
      location_zip_code: zip_code != null && zip_code !== "" ? String(zip_code) : "",
    });
  };

  // กันผลลัพธ์ที่ตอบช้ามาทับคำขอล่าสุด (เปลี่ยนลูกค้า/สินค้ารัว ๆ)
  serialNumberToken = 0;

  // Serial No. ค่าเริ่มต้น = รหัสลูกค้า-รหัสสินค้า-เลขรัน 3 หลัก (ผู้ใช้แก้ไขเองได้)
  // ใช้เฉพาะตอนสร้างใหม่ ไม่แตะ serial ของรายการที่บันทึกไปแล้ว
  applyDefaultSerialNumber = async (customer_id, part_id) => {
    const { uid, data_customer, data_part } = this.state;
    if (uid) return;

    const customer_code = data_customer?.find(e => e.value === customer_id)?.customer_code || "";
    const part_number = data_part?.find(e => e.value === part_id)?.part_number || "";
    if (!customer_code || !part_number) return;

    const prefix = customer_code + "-" + part_number + "-";
    const token = ++this.serialNumberToken;

    const result = await GET("admin/assets", { page: 0, page_size: 10000, customer_id: customer_id, lite: "true" });
    if (token !== this.serialNumberToken || this.state.uid) return;

    const running = (result?.status ? result.data || [] : []).reduce((max, item) => {
      const serial = String(item?.serial_number || "");
      if (!serial.startsWith(prefix)) return max;
      const suffix = Number(serial.slice(prefix.length));
      return Number.isInteger(suffix) && suffix > max ? suffix : max;
    }, 0);

    this.setState({ serial_number: prefix + String(running + 1).padStart(SERIAL_RUNNING_DIGITS, "0") });
  };

  Get = async (page = 1) => {
    let data = [], count = 0, data_finance = [], data_sale = [], data_part = [], data_project = [], data_department = [], data_cwc = [], data_machine_group = [], data_brand = [], data_model = [];
    let summary_count = { total: 0, active: 0, draft: 0, pending: 0, revise: 0, customer_warranty_expired: 0 };
    const { filter_search, filter_customer, filter_department, filter_status, filter_vendor_warranty } = this.state;
    // ตัวกรองสถานะช่องเดียว: true/false = เปิด/ปิดใช้งาน (is_active) ; draft/pending/revise = สถานะขึ้นทะเบียน
    const filter_is_active = filter_status === "true" || filter_status === "false" ? filter_status : "";
    const filter_registration_status = filter_status && !filter_is_active ? filter_status : "";
    loading(true);

    let [result, result_summary, result_finance, result_sale, result_part, result_project, result_department, result_cwc, result_machine_group, result_brand, result_model] = await Promise.all([
      GET("admin/assets", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        customer_id: filter_customer || "",
        department_id: filter_department || "",
        is_active: filter_is_active,
        registration_status: filter_registration_status,
        has_vendor_warranty: filter_vendor_warranty || "",
        type: "",
        uid: ""
      }),
      // summary=true: backend นับ KPI card จากทุกแถวที่ตรง filter — ไม่ต้องดึงทุกแถวมานับเอง
      GET("admin/assets", {
        summary: "true",
        data_search: filter_search || "",
        customer_id: filter_customer || "",
        department_id: filter_department || "",
        is_active: filter_is_active,
        registration_status: filter_registration_status,
        has_vendor_warranty: filter_vendor_warranty || "",
      }),
      GET("admin/finance-masters", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/sale-masters", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
       GET("warehouse/part-masters", {
                page_size: 10000,
        page: 0,
        data_search: "",
              }),
      GET("admin/projects", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/departments", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/customer-warranty-conditions", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/machine-groups", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      // master ยี่ห้อ = table brands (ดู glossary ใน components/global.js) — ไม่ใช้ series
      GET("warehouse/brands", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      // master รุ่น = table models (belongsTo brands) ดึงมาทั้งหมดครั้งเดียว แล้วกรองตามยี่ห้อที่เลือกในฟอร์ม
      GET("warehouse/models", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
    ]);

    if (result?.status) {
        data = result.data || [];
        count = result.pagination?.count || 0 ;
    }

    if (result_summary?.status && result_summary.data) {
      summary_count = { ...summary_count, ...result_summary.data };
    }

    if(result_finance?.status){
      data_finance = result_finance.data.map(e => ({ value: e.uid || e.uid, label: e.finance_code + " " + e.finance_name_th })) || [];
    }
    if(result_sale?.status){
      data_sale = result_sale.data.map(e => ({ value: e.uid || e.uid, label: e.sale_code + " "+e.name_th })) || [];
    }

    if(result_part?.status){
      // แสดงเป็น "part number ชื่อสินค้า" — Select กรองตัวเลือกจาก label จึงค้นหาด้วยชื่อสินค้าได้ด้วย
      data_part = result_part.data.map(e => ({ ...e, value: e.uid, label: [e.part_number, e.name].filter(Boolean).join(" ") })) || [];
    }

    if(result_project?.status){
      data_project = result_project.data.map(e => ({ ...e, value: e.uid, label: [e.project_code, e.name].filter(Boolean).join(" ") })) || [];
    }

    if(result_department?.status){
      // แสดงเป็น "รหัสหน่วยงาน ชื่อหน่วยงาน" (บางหน่วยงานยังไม่มีรหัส จึงต้องกันช่องว่างนำหน้า)
      data_department = result_department.data.map(e => ({ ...e, value: e.uid, label: [e.department_code, e.name].filter(Boolean).join(" ") })) || [];
    }

    if(result_cwc?.status){
      data_cwc = result_cwc.data
        .filter(e => e.is_active !== false)
        .map(e => ({ value: e.uid, label: (e.code ? e.code + " " : "") + (e.name || "") })) || [];
    }

    if(result_machine_group?.status){
      // value = รหัสกลุ่ม เพราะช่องระบบถูกใช้เป็นส่วนหนึ่งของรหัสเครื่องจักร
      const isEnglish = localStorage.getItem("lang") === "EN";
      data_machine_group = result_machine_group.data
        .filter(e => e.is_active !== false)
        .map(e => ({ value: e.code, label: `${(isEnglish && e.name_en) || e.name_th} (${e.code})` })) || [];
    }

    if(result_brand?.status){
      // value = ชื่อยี่ห้อ เพราะ assets เก็บ brand_name เป็นข้อความ ; uid ใช้จับคู่กับรุ่น (models.brand)
      data_brand = result_brand.data
        .filter(e => e.is_active !== false)
        .map(e => ({ value: e.name, label: e.name, uid: e.uid })) || [];
    }

    if(result_model?.status){
      // value = ชื่อรุ่น (assets เก็บ model_name เป็นข้อความ) ; brand_uid ใช้กรองให้เหลือเฉพาะรุ่นของยี่ห้อที่เลือก
      data_model = result_model.data
        .filter(e => e.is_active !== false && e.brand?.uid)
        .map(e => ({
          value: e.name,
          label: e.model_code && e.model_code !== e.name ? `${e.model_code} - ${e.name}` : e.name,
          brand_uid: e.brand.uid,
        })) || [];
    }

    this.setState({ data, count, summary_count, data_finance, data_sale, data_part, data_project, data_department, data_cwc, data_machine_group, data_brand, data_model });
    loading(false);
  };

  // อัปโหลดรูป/ไฟล์ของฟอร์มขึ้นทะเบียน แล้วคืนรายการสำหรับ registration_attachments (null = อัปโหลดไม่สำเร็จ)
  // groups: [{ category, items }] - category คือหมวดของไฟล์ (machine_photo, location_photo, key ของเอกสาร ...)
  uploadRegAttachments = async (groups) => {
    const uploaded = [];
    for (const { category, items } of groups) {
      for (const item of items || []) {
        if (item.failed) continue;
        const description = item.caption || null;

        // ไฟล์เดิมที่บันทึกไว้แล้ว - ส่ง uid กลับไปเพื่อคงไฟล์เดิม (อัปเดตได้เฉพาะคำอธิบาย/ลำดับ)
        if (!item.file) {
          uploaded.push({ uid: item.uid || undefined, category, description, file_path: item.url, file_name: limitFileName(item.name), file_type: item.file_type || undefined, mime_type: limitMime(item.mime_type), file_size: item.file_size ?? null });
          continue;
        }

        const res = await UPLOAD(item.file, { folder: "assets/registration" });
        if (res?.status !== true || !res?.data?.file_path) {
          alert("", "warning", t("warning"), `${t("upload")} "${item.name || ""}" ${t("fail")}`);
          return null;
        }
        uploaded.push({
          category,
          description,
          file_path: res.data.file_path,
          file_name: limitFileName(item.name || res.data.file_name),
          file_type: res.data.file_type || undefined,
          mime_type: limitMime(res.data.mime_type || item.type),
          file_size: res.data.file_size ?? item.size ?? null,
        });
      }
    }
    return uploaded;
  };

  CreateUpdate = async () => {
    const {
      uid, company_id, project_id, department_id, customer_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, latitude, longitude, location_remark,
      reg_received_date, reg_machine_name, reg_system, reg_reference, reg_machine_status, reg_brand, reg_model, reg_no_serial,
      reg_capacity, reg_width, reg_length, reg_height, reg_weight, reg_weight_unit, reg_electric, reg_power_kw, reg_utility,
      reg_machine_photos, reg_location_department, reg_soi, reg_road, reg_location_photos,
      reg_documents, reg_training_docs, reg_training_levels, reg_training_evaluation, reg_training_evaluation_files,
      reg_other_files, reg_remark,
    } = this.state;

    // บันทึก/แก้ไขต้องกรอกช่องบังคับ (*) ให้ครบทุกช่อง - backend ตรวจชุดเดียวกัน (AssetRegistrationRequiredFields)
    // ส่วนไฟล์แนบของเอกสารที่ติ๊กไว้ ตรวจตอนกดส่งอนุมัติ (submitRegForApproval)
    const { missing, latitudeInvalid, longitudeInvalid, latitudeMissing, longitudeMissing } = this.getRegValidation();
    const missingFields = REG_REQUIRED_FIELDS.filter((field) => missing[field.key]);
    if (missingFields.length > 0) {
      alert("", "warning", t("warning"), `${t("reg_validate_required")} ${missingFields.map((field) => t(field.label)).join(", ")}`);
      this.setState({ reg_show_errors: true }, () => this.scrollToRegSection("reg-field-" + missingFields[0].key, "center"));
      return;
    }
    if (latitudeInvalid || longitudeInvalid || latitudeMissing || longitudeMissing) {
      alert("", "warning", t("warning"), latitudeInvalid ? t("reg_validate_latitude") : longitudeInvalid ? t("reg_validate_longitude") : t("reg_validate_coordinates_pair"));
      this.scrollToRegSection("reg-field-coordinates", "center");
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const documentKeys = [...REG_DOCUMENT_KEYS, ...REG_INSPECTION_KEYS];
      const registration_attachments = await this.uploadRegAttachments([
        { category: "machine_photo", items: reg_machine_photos },
        { category: "location_photo", items: reg_location_photos },
        ...documentKeys.map((key) => ({ category: key, items: reg_documents[key]?.files })),
        { category: "training_evaluation", items: reg_training_evaluation === "yes" ? reg_training_evaluation_files : [] },
        { category: "other", items: reg_other_files },
      ]);
      if (registration_attachments === null) {
        loading(false);
        return;
      }

      const text = (value) => String(value ?? "").trim();
      // ฟิลด์เดิมที่ไม่อยู่ในฟอร์มนี้ (สินค้า / ใบกำกับภาษี / ประกัน / ผู้ติดต่อ / แท็ก) ไม่ส่งไป - backend คงค่าเดิมไว้
      let body = {
        company_id,
        department_id,
        project_id: project_id || "",
        // ลูกค้าไม่บังคับ: ส่งเฉพาะเมื่อเลือกไว้
        ...(customer_id ? { customer_id } : {}),
        received_date: reg_received_date || null,
        machine_name: text(reg_machine_name),
        machine_group_code: reg_system || "",
        reference_no: text(reg_reference),
        machine_status: reg_machine_status || "",
        brand_name: reg_brand || "",
        model_name: text(reg_model),
        no_serial: reg_no_serial,
        serial_number: reg_no_serial ? "" : text(serial_number),
        price: text(price) === "" ? null : parseFloat(price) || 0,
        // ข้อมูลจำเพาะของเครื่อง เก็บเป็น key -> value (ช่องว่าง backend จะตัดทิ้ง)
        specifications: {
          capacity: text(reg_capacity),
          width_mm: text(reg_width),
          length_mm: text(reg_length),
          height_mm: text(reg_height),
          weight: text(reg_weight),
          weight_unit: text(reg_weight) ? reg_weight_unit : "",
          electric: text(reg_electric),
          power_kw: text(reg_power_kw),
          utility: text(reg_utility),
        },
        location_department_id: reg_location_department || department_id,
        location_running_number: location_running_number || "",
        location_name: location_name || "",
        location_address: location_address || "",
        location_soi: text(reg_soi),
        location_road: text(reg_road),
        location_province: location_province || "",
        location_district: location_district || "",
        location_sub_district: location_sub_district || "",
        // ส่งเป็น string เสมอ (backend DTO รับเฉพาะ string) กัน zip code ที่ยังเป็น number หลุดไป
        location_zip_code: location_zip_code != null && location_zip_code !== "" ? String(location_zip_code) : "",
        latitude: text(latitude),
        longitude: text(longitude),
        location_remark: location_remark || "",
        registration_checklist: {
          documents: Object.fromEntries(documentKeys.map((key) => [key, Boolean(reg_documents[key]?.checked)])),
          training_courses: Object.fromEntries(REG_TRAINING_COURSES.map((course) => [course, Boolean(reg_training_docs[course])])),
          training_levels: Object.fromEntries(
            REG_TRAINING_LEVELS.map((level) => [level, { checked: Boolean(reg_training_levels[level]?.checked), date: reg_training_levels[level]?.date || null }]),
          ),
          training_evaluation: reg_training_evaluation === "yes",
        },
        remark: reg_remark || "",
        registration_attachments,
        // ปุ่ม "บันทึกร่าง" = กลับเป็นร่างเสมอ (รวมรายการเดิมที่อนุมัติแล้ว) จนกว่าจะกดส่งอนุมัติใหม่
        registration_status: "draft",
      };

      let result = !uid
        ? await POST("admin/assets", body)
        : await PUT("admin/assets/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.closeModalWithAnimation("modal_create");
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/assets/" + id, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  // --- Handlers ---

  closeModalWithAnimation = (modalKey) => {
    const closingKey = `${modalKey}_closing`;
    if (!this.state[modalKey] || this.state[closingKey]) {
      return;
    }

    if (this.modalCloseTimer) {
      clearTimeout(this.modalCloseTimer);
    }

    this.setState({ [closingKey]: true });
    this.modalCloseTimer = setTimeout(() => {
      this.setState({ [modalKey]: false, [closingKey]: false });
      this.modalCloseTimer = null;
    }, 220);
  };

  appendCwcToRemark = () => {
    const { selected_cwc, data_cwc, customer_warranty_remark } = this.state;
    if (!selected_cwc) return;
    const item = data_cwc.find(e => e.value === selected_cwc);
    if (!item) return;
    const current = customer_warranty_remark || "";
    const newText = current ? current + "\n" + item.label : item.label;
    if (newText.length > 500) {
      alert("", "warning", t("warning"), t("validate_remark_max_length"));
      return;
    }
    this.setState({ customer_warranty_remark: newText, selected_cwc: "" });
  };

  mapCwcFilesToItems = (files) =>
    Array.from(files).map((file) => ({
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
    }));

  filterValidCwcFiles = (files) => {
    const max = MAX_UPLOAD_SIZE.default;
    const arr = Array.from(files || []);
    const tooBig = arr.filter((f) => f.size > max);
    if (tooBig.length > 0) {
      const mb = Math.round(max / 1024 / 1024);
      alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${tooBig.map((f) => f.name).join(", ")}`);
    }
    return arr.filter((f) => f.size <= max);
  };

  handleCwcDragOver = (e) => e.preventDefault();

  handleCwcDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const newItems = this.mapCwcFilesToItems(this.filterValidCwcFiles(e.dataTransfer.files));
      this.setState((prev) => ({ cwc_attachments: [...prev.cwc_attachments, ...newItems] }));
      e.dataTransfer.clearData();
    }
  };

  removeCwcAttachment = async (index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => {
      const updated = [...prev.cwc_attachments];
      if (updated[index]?.url?.startsWith("blob:")) URL.revokeObjectURL(updated[index].url);
      updated.splice(index, 1);
      return { cwc_attachments: updated };
    });
  };

  uploadCwcAttachments = async (items) => {
    const uploaded = [];
    for (const item of items || []) {
      if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
        uploaded.push({
          uid: item.uid || undefined,
          file_path: item.url,
          file_name: limitFileName(item.name),
          file_type: item.file_type || "document",
          mime_type: limitMime(item.mime_type),
          file_size: item.file_size ?? null,
        });
        continue;
      }
      const max = MAX_UPLOAD_SIZE.default;
      if (item?.file && item.file.size > max) {
        const mb = Math.round(max / 1024 / 1024);
        alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${item?.name || ""}`);
        return null;
      }
      const res = await UPLOAD(item.file, { folder: "assets/customer-warranty-attachments" });
      if (res?.status === true && res?.data?.file_path) {
        uploaded.push({
          file_path: res.data.file_path,
          file_name: limitFileName(item.name || res.data.file_name),
          file_type: res.data.file_type || "document",
          mime_type: limitMime(res.data.mime_type || item.type),
          file_size: res.data.file_size ?? item.size ?? null,
        });
      } else {
        alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
        return null;
      }
    }
    return uploaded;
  };

  openModalCreate = () => {
    this.setState({
      modal_create: true,
      modal_create_closing: false,
      uid: "",
      asset_code: "",
      project_id: "",
      department_id: "",
      sequence: 1, customer_id: "", finance_id: "", sale_id: "", part_id: "", serial_number: "", price: "",
      location_running_number: "", location_name: "", location_address: "", location_province: "", location_district: "", location_sub_district: "", location_zip_code: "", location_floor_room: "", latitude: "", longitude: "", location_remark: "",
      contract_name: "", contract_phone: "", contract_email: "",
      invoice_number: "", invoice_date: "", coi_date: "",
      replacement_period: "",
      customer_warranty: [{ customer_warranty_month: "", customer_warranty_expire_date: "", customer_warranty_renew_date: "", customer_warranty_renew_remark: "" }], customer_warranty_count: 0, customer_warranty_remark: "",
      company_warranty: [{ company_warranty_month: "", company_warranty_expire_date: "", company_warranty_renew_date: "", company_warranty_renew_remark: "" }], company_warranty_count: 0, company_warranty_remark: "",
      tag_name: "", tags: [], is_active: true, registration_status: "draft", selected_cwc: "", cwc_attachments: [],
      created_by: "", created_at: null, updated_by: "", updated_at: null,
      ...this.getRegistrationFormDefaults(),
    });
  }

  toRegFileItem = (attachment) => ({
    uid: attachment.uid,
    url: attachment.file_path,
    name: attachment.file_name || attachment.file_path?.split("/").pop() || "",
    file_type: attachment.file_type,
    mime_type: attachment.mime_type,
    file_size: attachment.file_size,
    caption: attachment.description || "",
  });

  // แปลงข้อมูล asset จาก API เป็น state ของฟอร์มขึ้นทะเบียน (reg_*)
  mapAssetToRegistrationState = (data = {}) => {
    const specifications = data.specifications || {};
    const checklist = data.registration_checklist || {};

    const filesByCategory = {};
    (data.registration_attachments || []).forEach((attachment) => {
      if (!filesByCategory[attachment.category]) filesByCategory[attachment.category] = [];
      filesByCategory[attachment.category].push(this.toRegFileItem(attachment));
    });

    const reg_documents = {};
    [...REG_DOCUMENT_KEYS, ...REG_INSPECTION_KEYS].forEach((key) => {
      const files = filesByCategory[key] || [];
      const checked = Boolean(checklist.documents?.[key]);
      if (checked || files.length > 0) reg_documents[key] = { checked, files };
    });

    const reg_training_levels = {};
    Object.entries(checklist.training_levels || {}).forEach(([level, value]) => {
      reg_training_levels[level] = { checked: Boolean(value?.checked), date: value?.date || "" };
    });

    return {
      reg_document_number: data.document_number || "",
      reg_received_date: data.received_date || "",
      reg_machine_name: data.machine_name || data.part_name || "",
      reg_system: data.machine_group_code || "",
      reg_reference: data.reference_no || "",
      reg_machine_status: data.machine_status || "new",
      reg_brand: data.brand_name || "",
      reg_model: data.model_name || "",
      reg_no_serial: Boolean(data.no_serial),
      reg_capacity: specifications.capacity ?? "",
      reg_width: specifications.width_mm ?? "",
      reg_length: specifications.length_mm ?? "",
      reg_height: specifications.height_mm ?? "",
      reg_weight: specifications.weight ?? "",
      reg_weight_unit: specifications.weight_unit || "Kg",
      reg_electric: specifications.electric ?? "",
      reg_power_kw: specifications.power_kw ?? "",
      reg_utility: specifications.utility ?? "",
      reg_machine_photos: filesByCategory.machine_photo || [],
      reg_location_department: data.location_department?.uid || "",
      reg_soi: data.location_soi || "",
      reg_road: data.location_road || "",
      reg_location_photos: filesByCategory.location_photo || [],
      reg_documents,
      reg_training_docs: checklist.training_courses || {},
      reg_training_levels,
      reg_training_evaluation: checklist.training_evaluation ? "yes" : "no",
      reg_training_evaluation_files: filesByCategory.training_evaluation || [],
      reg_other_files: filesByCategory.other || [],
      reg_remark: data.remark || "",
    };
  };

  // เปิดฟอร์มของรายการเดิม - readonly = โหมดดูรายละเอียด (ใช้ฟอร์มเดียวกัน แต่แก้ไข/บันทึกไม่ได้)
  openModalUpdate = async (item, readonly = false) => {
    loading(true);
    let result = await GET("admin/assets", { uid: item.uid })
    if (result.status === true) {
      let data = result.data;
      this.pinCustomer(data?.customer);
      this.setState({
        modal_create: true,
        modal_create_closing: false,
        ...this.getRegistrationFormDefaults(),
        ...data,
        ...this.mapAssetToRegistrationState(data),
        reg_readonly: readonly,
        uid: data?.uid,
        project_id: data?.project?.uid || "",
        department_id: data?.department?.uid || "",
        customer_id: data?.customer?.uid || "",
        serial_number: data?.serial_number || "",
        price: data?.price ?? "",
        latitude: data?.latitude || "",
        longitude: data?.longitude || "",
      });
    }
    loading(false);
  }

  openModalDetail = (item) => this.openModalUpdate(item, true);

  normalizeWarrantyEntries = (entries, monthKey, expireKey) => {
    return (entries || []).filter(
      (item) =>
        item &&
        (
          String(item[monthKey] ?? "").trim() !== "" ||
          String(item[expireKey] ?? "").trim() !== ""
        ),
    );
  };

  normalizeAssetWarrantyState = (data = {}) => {
    const customerWarranty =
      data?.customer_warranty?.map((item) => ({
        customer_warranty_month: item?.customer_warranty_month?.toString?.() || item?.customer_warranty_month || "",
        customer_warranty_expire_date: item?.customer_warranty_expire_date
          ? format_date(item.customer_warranty_expire_date, "yyyy-mm-dd", "en")
          : "",
        customer_warranty_renew_date: item?.customer_warranty_renew_date
          ? format_date(item.customer_warranty_renew_date, "yyyy-mm-dd", "en")
          : "",
        customer_warranty_renew_remark: item?.customer_warranty_renew_remark || "",
      })) ||
      [];

    const companyWarranty =
      data?.company_warranty?.map((item) => ({
        company_warranty_month: item?.company_warranty_month?.toString?.() || item?.company_warranty_month || "",
        company_warranty_expire_date: item?.company_warranty_expire_date
          ? format_date(item.company_warranty_expire_date, "yyyy-mm-dd", "en")
          : "",
        company_warranty_renew_date: item?.company_warranty_renew_date
          ? format_date(item.company_warranty_renew_date, "yyyy-mm-dd", "en")
          : "",
        company_warranty_renew_remark: item?.company_warranty_renew_remark || "",
      })) ||
      [];

    const normalizedCustomerWarranty = customerWarranty.length
      ? customerWarranty
      : [{
          customer_warranty_month: data?.customer_warranty_month?.toString?.() || data?.customer_warranty_month || "",
          customer_warranty_expire_date: data?.customer_warranty_expire_date
            ? format_date(data.customer_warranty_expire_date, "yyyy-mm-dd", "en")
            : "",
        }];

    const normalizedCompanyWarranty = companyWarranty.length
      ? companyWarranty
      : [{
          company_warranty_month: data?.company_warranty_month?.toString?.() || data?.company_warranty_month || "",
          company_warranty_expire_date: data?.company_warranty_expire_date
            ? format_date(data.company_warranty_expire_date, "yyyy-mm-dd", "en")
            : "",
        }];

    return {
      customer_warranty: normalizedCustomerWarranty,
      customer_warranty_count: normalizedCustomerWarranty.filter(
        (item) =>
          String(item.customer_warranty_month ?? "").trim() !== "" ||
          String(item.customer_warranty_expire_date ?? "").trim() !== "",
      ).length,
      company_warranty: normalizedCompanyWarranty,
      company_warranty_count: normalizedCompanyWarranty.filter(
        (item) =>
          String(item.company_warranty_month ?? "").trim() !== "" ||
          String(item.company_warranty_expire_date ?? "").trim() !== "",
      ).length,
    };
  };

  getLatestWarrantyExpireDate = (warrantyList, monthKey, expireKey, fallback = "") => {
    const normalizedList = this.normalizeWarrantyEntries(
      warrantyList,
      monthKey,
      expireKey,
    );
    const latestExpireDate = normalizedList.reduce((latest, item) => {
      const currentExpireDate = String(item?.[expireKey] || "").trim();

      if (!currentExpireDate) {
        return latest;
      }

      if (!latest) {
        return currentExpireDate;
      }

      return new Date(currentExpireDate) > new Date(latest) ? currentExpireDate : latest;
    }, "");

    return latestExpireDate || fallback || "";
  };

  // ครั้งแรกใช้ "วันที่เริ่มประกัน" ของตัวเองเป็นฐาน (ไม่คำนวณจากวันที่ EOI แล้ว)
  // ครั้งที่ 2 เป็นต้นไป ใช้ "วันที่ต่อประกัน" ของตัวเองเป็นฐาน (ถ้ามี)
  // ถ้ายังไม่ได้ระบุ (ข้อมูลเก่าก่อนมี field นี้) ให้ใช้วันหมดประกันของครั้งก่อนหน้าแทน
  getWarrantyBaseDate = (warrantyList, index, expireKey, renewKey) => {
    if (index === 0) {
      return warrantyList?.[0]?.[renewKey] || "";
    }

    return warrantyList?.[index]?.[renewKey] || addDaysToDate(warrantyList?.[index - 1]?.[expireKey], 1);
  };

  updateWarrantyMonthValue = (section, index, value) => {
    if (String(value).includes("-")) {
      return;
    }

    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, renewKey);

    warrantyList[index] = {
      ...warrantyList[index],
      [monthKey]: value,
      [expireKey]: baseDate && value !== "" ? this.addMonthsToDate(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  updateWarrantyExpireValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, renewKey);

    warrantyList[index] = {
      ...warrantyList[index],
      [expireKey]: value,
      [monthKey]: baseDate && value ? this.getMonthDiff(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  // วันที่ต่อประกัน ครั้งที่ 2 เป็นต้นไป: default มาจากวันหมดประกันของครั้งก่อนหน้า แต่แก้ไขได้เอง
  updateWarrantyRenewDateValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const currentMonth = warrantyList[index]?.[monthKey];

    warrantyList[index] = {
      ...warrantyList[index],
      [renewKey]: value,
      [expireKey]:
        value && currentMonth !== "" && currentMonth !== null && currentMonth !== undefined
          ? this.addMonthsToDate(value, currentMonth)
          : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  // หมายเหตุของการต่อประกันแต่ละครั้ง (ครั้งที่ 2 เป็นต้นไป)
  updateWarrantyRenewRemarkValue = (section, index, value) => {
    const remarkKey = `${section}_warranty_renew_remark`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];

    warrantyList[index] = { ...warrantyList[index], [remarkKey]: value };

    this.setState({ [warrantyKey]: warrantyList });
  };

  recalculateWarrantyList = (list, monthKey, expireKey, renewKey) => {
    return (list || []).reduce((acc, item, index) => {
      const prevExpire = index === 0 ? "" : (acc[index - 1]?.[expireKey] || "");
      const baseDate = item?.[renewKey] || addDaysToDate(prevExpire, 1);
      const renewDate = baseDate;

      acc.push({
        ...item,
        [renewKey]: renewDate,
        [expireKey]:
          baseDate && item?.[monthKey] !== "" && item?.[monthKey] !== null
            ? this.addMonthsToDate(baseDate, item[monthKey])
            : "",
      });

      return acc;
    }, []);
  };

  addWarrantyEntry = (section) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const remarkKey = `${section}_warranty_renew_remark`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const latestEntry = warrantyList[warrantyList.length - 1];

    if (String(latestEntry?.[monthKey] ?? "").trim() === "" || Number(latestEntry?.[monthKey]) < 0 || !latestEntry?.[expireKey]) {
      alert("", "warning", t("warning"), t("validate_warranty_latest_entry_complete"));
      return;
    }

    warrantyList.push({
      [monthKey]: "",
      [expireKey]: "",
      [renewKey]: addDaysToDate(latestEntry?.[expireKey], 1),
      [remarkKey]: "",
    });

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  deleteWarrantyEntry = async (section, index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;

    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const currentList = [...(this.state[warrantyKey] || [])];
    const filteredList = currentList.filter((_, itemIndex) => itemIndex !== index);
    const nextList = filteredList.length
      ? this.recalculateWarrantyList(filteredList, monthKey, expireKey, renewKey)
      : [{ [monthKey]: "", [expireKey]: "" }];

    this.setState({
      [warrantyKey]: nextList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        nextList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  isWarrantyListComplete = (warrantyList, monthKey, expireKey) => {
    return warrantyList.every(
      (item) =>
        Number(item?.[monthKey]) > 0 &&
        !!item?.[expireKey],
    );
  };

  isLatestWarrantyEntryComplete = (warrantyList, monthKey, expireKey) => {
    const latestEntry = warrantyList?.[warrantyList.length - 1];
    return Number(latestEntry?.[monthKey]) > 0 && !!latestEntry?.[expireKey];
  };

  getAssetLatestWarrantyExpireDate = (item, section) => {
    const warrantyKey = `${section}_warranty`;
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;

    const normalizedWarranty = this.normalizeAssetWarrantyState(item)?.[warrantyKey] || [];
    const latestExpireDate = this.getLatestWarrantyExpireDate(
      normalizedWarranty,
      monthKey,
      expireKey,
      item?.[expireKey] || "",
    );

    return latestExpireDate || item?.[expireKey] || "";
  };

  // ตรวจว่าวันหมดประกันเลยวันที่ปัจจุบันแล้วหรือยัง (ไม่มีวันที่ = ถือว่าหมดอายุ)
  isWarrantyExpired = (expireDate) => {
    const raw = String(expireDate || "").trim();
    if (!raw) return true;
    const parsed = new Date(raw.split("T")[0]);
    if (isNaN(parsed.getTime())) return true;
    parsed.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return parsed < today;
  };

  // "ชื่อผู้ใช้ (วันที่เวลา น.)" สำหรับกล่องข้อมูลการบันทึก/แก้ไขในหน้ารายละเอียด
  formatUserActivity = (name, dateValue) => {
    if (!name) return "-";
    const datePart = dateValue ? ` ${format_date(dateValue, "dd/mm/yyyy hh:mm", "th")} ${t("unit_oclock")}` : "";
    return datePart ? `${name} (${datePart})` : name;
  };

  // วันหมดประกัน = วันเริ่ม + N เดือน - 1 วัน (สิ้นเดือนที่ต้อง clamp = วันสุดท้ายของเดือน) ดู utils/warranty.js
  addMonthsToDate = (dateString, months) => {
    if (!dateString || months === "" || months === null || months === undefined) return "";
    return calcWarrantyExpireDate(dateString, months);
  };

  getMonthDiff = (startDateString, endDateString) => calcWarrantyMonthDiff(startDateString, endDateString);

  renderModalAnimationStyle = () => (
    <style>{`
      .asset-modal-backdrop {
        animation: assetBackdropFadeIn 180ms ease-out;
      }

      .asset-modal-dialog {
        animation: assetModalLiftIn 220ms ease-out;
        transform-origin: center center;
      }

      .asset-modal-backdrop.is-closing {
        animation: assetBackdropFadeOut 220ms ease-in forwards;
      }

      .asset-modal-dialog.is-closing {
        animation: assetModalLiftOut 220ms ease-in forwards;
      }

      @keyframes assetBackdropFadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes assetModalLiftIn {
        from {
          opacity: 0;
          transform: translateY(14px) scale(0.985);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      @keyframes assetBackdropFadeOut {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }

      @keyframes assetModalLiftOut {
        from {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
        to {
          opacity: 0;
          transform: translateY(10px) scale(0.99);
        }
      }

      /* โหมดดูรายละเอียด: ช่องกรอกกดไม่ได้ และซ่อนปุ่มแนบ/ลบไฟล์ (ลิงก์เปิดไฟล์ยังกดได้) */
      .reg-readonly .form-control,
      .reg-readonly .form-select,
      .reg-readonly .form-check-input,
      .reg-readonly .form-check-input + *,
      .reg-readonly label.pointer {
        pointer-events: none;
      }

      .reg-readonly label.btn,
      .reg-readonly .reg-edit-only {
        display: none !important;
      }

      @media (prefers-reduced-motion: reduce) {
        .asset-modal-backdrop,
        .asset-modal-dialog {
          animation: none !important;
        }
      }
    `}</style>
  );

  // --- ฟอร์มขึ้นทะเบียนเครื่องจักร (FMN-03) ---

  // ฟิลด์ตาม wireframe FMN-03 ที่ยังเป็น UI อย่างเดียว (ยังไม่ส่งไป API / ยังไม่ถูกบันทึก)
  getRegistrationFormDefaults = () => ({
    reg_document_number: "",
    reg_received_date: "",
    reg_machine_name: "",
    reg_system: "",
    reg_reference: "",
    reg_machine_status: "new",
    reg_brand: "",
    reg_model: "",
    reg_no_serial: false,
    reg_capacity: "",
    reg_width: "",
    reg_length: "",
    reg_height: "",
    reg_weight: "",
    reg_weight_unit: "Kg",
    reg_electric: "",
    reg_power_kw: "",
    reg_utility: "",
    reg_machine_photos: [],
    reg_location_department: "",
    reg_soi: "",
    reg_road: "",
    reg_location_photos: [],
    reg_documents: {}, // { [key]: { checked, files } } ของข้อ 6 และข้อ 8
    reg_training_docs: {},
    reg_training_levels: {}, // { [level]: { checked, date } }
    reg_training_evaluation: "no",
    reg_training_evaluation_files: [],
    reg_other_files: [],
    reg_remark: "",
    reg_approval_comment: "",
    reg_gps_status: null, // { type: "primary" | "success" | "warning" | "danger", text }
    reg_show_errors: false, // เปิดหลังกดบันทึก/ส่งอนุมัติแล้วข้อมูลไม่ครบ - ช่องบังคับที่ว่างจะขึ้นสีแดง
    reg_readonly: false, // โหมดดูรายละเอียด
  });

  scrollToRegSection = (id, block = "start") => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block });
  };

  // ตรวจฟอร์มขึ้นทะเบียน - ใช้ทั้งตอนแสดงผล (ช่องสีแดง/ข้อความใต้ช่อง) และตอนกดส่งอนุมัติ
  // errors เรียงตามลำดับบนหน้าจอ: { id: DOM id ของช่องที่ผิด, step: ขั้นตอนใน stepper }
  getRegValidation = () => {
    const {
      department_id, latitude, longitude,
      reg_received_date, reg_machine_name, reg_system, reg_brand, reg_model,
      reg_documents, reg_training_evaluation, reg_training_evaluation_files,
    } = this.state;

    const missing = {};
    const errors = [];
    const values = { department: department_id, received_date: reg_received_date, machine_name: reg_machine_name, system: reg_system, brand: reg_brand, model: reg_model };
    REG_REQUIRED_FIELDS.forEach((field) => {
      if (String(values[field.key] ?? "").trim()) return;
      missing[field.key] = true;
      errors.push({ id: "reg-field-" + field.key, step: field.step });
    });

    // พิกัดไม่บังคับ แต่ถ้ากรอกต้องกรอกครบทั้งคู่ และอยู่ในช่วงพิกัดประเทศไทย
    const inLatitudeRange = (value) => value >= 5.6 && value <= 20.5;
    const inLongitudeRange = (value) => value >= 97.3 && value <= 105.7;
    const latitudeText = String(latitude ?? "").trim();
    const longitudeText = String(longitude ?? "").trim();
    const latitudeInvalid = latitudeText !== "" && !inLatitudeRange(parseFloat(latitudeText));
    const longitudeInvalid = longitudeText !== "" && !inLongitudeRange(parseFloat(longitudeText));
    const latitudeMissing = latitudeText === "" && longitudeText !== "";
    const longitudeMissing = longitudeText === "" && latitudeText !== "";
    const coordinatesSwapped = inLongitudeRange(parseFloat(latitudeText)) && inLatitudeRange(parseFloat(longitudeText));
    const hasCoordinates = latitudeText !== "" && longitudeText !== "" && !latitudeInvalid && !longitudeInvalid;
    if (latitudeInvalid || longitudeInvalid || latitudeMissing || longitudeMissing) {
      errors.push({ id: "reg-field-coordinates", step: 3 });
    }

    // ติ๊กเอกสารแล้วต้องมีไฟล์แนบ
    [...REG_DOCUMENT_KEYS, ...REG_INSPECTION_KEYS].forEach((key) => {
      const doc = reg_documents[key];
      if (doc?.checked && doc.files.length === 0) errors.push({ id: "reg-doc-" + key, step: 4 });
    });
    const evaluationFileMissing = reg_training_evaluation === "yes" && reg_training_evaluation_files.length === 0;
    if (evaluationFileMissing) errors.push({ id: "reg-field-training-evaluation", step: 4 });
    errors.sort((a, b) => a.step - b.step);

    return {
      missing, errors,
      latitudeText, longitudeText, latitudeInvalid, longitudeInvalid, latitudeMissing, longitudeMissing,
      coordinatesSwapped, hasCoordinates,
      documentsComplete: !errors.some((error) => error.step === 4),
    };
  };

  // ยังไม่มี API ส่งอนุมัติ - ตอนนี้ตรวจความครบถ้วนและพาไปยังช่องแรกที่ผิดเท่านั้น
  submitRegForApproval = () => {
    const { errors } = this.getRegValidation();
    if (errors.length > 0) {
      this.setState({ reg_show_errors: true }, () => this.scrollToRegSection(errors[0].id, "center"));
      return;
    }
    this.setState({ reg_show_errors: false });
    alert("", "info", t("submit_for_approval"), t("reg_submit_not_available"));
  };

  swapRegCoordinates = () => {
    this.setState((prev) => ({ latitude: prev.longitude, longitude: prev.latitude }));
  };

  removeRegFailedPhoto = (key, url) => {
    this.setState((prev) => ({ [key]: (prev[key] || []).filter((item) => item.url !== url) }));
  };

  addRegFiles = (key, files) => {
    const items = this.mapCwcFilesToItems(this.filterValidCwcFiles(files));
    if (items.length === 0) return;
    this.setState((prev) => ({ [key]: [...(prev[key] || []), ...items] }));
  };

  // รูป: คัดเฉพาะไฟล์รูปที่ไม่เกิน 10 MB แล้วย่อขนาดอัตโนมัติก่อนเก็บเข้าฟอร์ม
  // ไฟล์ที่ไม่ผ่านจะขึ้นเป็นการ์ดสีแดงในรายการรูป (ไม่นับเป็นรูป) ให้ผู้ใช้กดลบเอง
  addRegPhotos = async (key, fileList) => {
    const { accepted, wrongType, tooBig, rule } = pickFilesByRule(fileList, "image", 0, REG_PHOTO_RULES);
    const batch = Date.now();
    const failedItems = [
      ...tooBig.map((name) => ({ name, failed: `${t("reg_photo_too_large")} ${toMB(rule.maxSize)} MB` })),
      ...wrongType.map((name) => ({ name, failed: t("reg_photo_wrong_type") })),
    ].map((item, index) => ({ ...item, url: `failed-${batch}-${index}` }));

    let items = [];
    if (accepted.length > 0) {
      loading(true);
      const compressed = await compressImageFiles(accepted);
      loading(false);
      items = this.mapCwcFilesToItems(compressed).map((item) => ({ ...item, caption: "" }));
    }
    if (items.length === 0 && failedItems.length === 0) return;

    this.setState((prev) => ({ [key]: [...(prev[key] || []), ...items, ...failedItems] }));
  };

  removeRegFile = async (key, index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => {
      const updated = [...(prev[key] || [])];
      if (updated[index]?.url?.startsWith("blob:")) URL.revokeObjectURL(updated[index].url);
      updated.splice(index, 1);
      return { [key]: updated };
    });
  };

  setRegPhotoCaption = (key, index, caption) => {
    this.setState((prev) => ({
      [key]: (prev[key] || []).map((item, i) => (i === index ? { ...item, caption } : item)),
    }));
  };

  // รูปหลัก = รูปแรกของรายการ
  setRegPhotoCover = (key, index) => {
    this.setState((prev) => {
      const updated = [...(prev[key] || [])];
      const [cover] = updated.splice(index, 1);
      return { [key]: [cover, ...updated] };
    });
  };

  toggleRegDocument = (key) => {
    this.setState((prev) => {
      const current = prev.reg_documents[key] || { checked: false, files: [] };
      return { reg_documents: { ...prev.reg_documents, [key]: { ...current, checked: !current.checked } } };
    });
  };

  // แนบไฟล์แล้วถือว่าติ๊กข้อนั้นให้เลย
  addRegDocumentFiles = (key, files) => {
    const items = this.mapCwcFilesToItems(this.filterValidCwcFiles(files));
    if (items.length === 0) return;
    this.setState((prev) => {
      const current = prev.reg_documents[key] || { checked: false, files: [] };
      return { reg_documents: { ...prev.reg_documents, [key]: { checked: true, files: [...current.files, ...items] } } };
    });
  };

  removeRegDocumentFile = async (key, index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => {
      const current = prev.reg_documents[key] || { checked: false, files: [] };
      const files = [...current.files];
      if (files[index]?.url?.startsWith("blob:")) URL.revokeObjectURL(files[index].url);
      files.splice(index, 1);
      return { reg_documents: { ...prev.reg_documents, [key]: { ...current, files } } };
    });
  };

  toggleRegNoSerial = () => {
    const { reg_no_serial, serial_number } = this.state;
    if (reg_no_serial) {
      this.setState({ reg_no_serial: false, serial_number: this.regSerialBackup || "" });
      return;
    }
    this.regSerialBackup = serial_number;
    this.setState({ reg_no_serial: true, serial_number: "" });
  };

  useRegCurrentPosition = () => {
    if (!navigator.geolocation) {
      this.setState({ reg_gps_status: { type: "danger", text: t("reg_gps_not_supported") } });
      return;
    }
    this.setState({ reg_gps_status: { type: "primary", text: t("reg_gps_locating") } });
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const accuracy = Math.round(position.coords.accuracy);
        this.setState({
          latitude: position.coords.latitude.toFixed(6),
          longitude: position.coords.longitude.toFixed(6),
          reg_gps_status: accuracy > REG_GPS_LOW_ACCURACY_METERS
            ? { type: "warning", text: formatText(t("reg_gps_low_accuracy"), { accuracy }) }
            : { type: "success", text: `${t("reg_gps_success")} ±${accuracy} ${t("reg_unit_meter")}` },
        });
      },
      () => this.setState({ reg_gps_status: { type: "danger", text: t("reg_gps_denied") } }),
    );
  };

  // การ์ดรูป: พรีวิว + คำอธิบายรายรูป + ตั้งรูปหลัก + ลบ
  renderRegPhotoGrid = (key, inputId) => {
    const photos = this.state[key] || [];
    const coverIndex = photos.findIndex((photo) => !photo.failed);
    return (
      <div className="row g-2">
        {photos.map((photo, index) => photo.failed ? (
          <div key={photo.url} className="col-6 col-md-4 col-xl-3">
            <div className="border border-danger rounded-3 overflow-hidden bg-white h-100">
              <div className="bg-danger-light text-danger text-12 fw-bold d-flex align-items-center justify-content-center text-center p-2" style={{ aspectRatio: "4 / 3" }}>
                {photo.failed}
              </div>
              <div className="p-2 d-flex align-items-center justify-content-between gap-2">
                <span className="text-12 text-muted text-truncate" title={photo.name}>{photo.name}</span>
                <button type="button" className="btn btn-outline-danger btn-sm text-12 text-nowrap" onClick={() => this.removeRegFailedPhoto(key, photo.url)}>
                  {t("delete")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div key={photo.url} className="col-6 col-md-4 col-xl-3">
            <div className="border rounded-3 overflow-hidden position-relative bg-white h-100">
              <a href={photo.url} target="_blank" rel="noopener noreferrer">
                <img src={photo.url} alt={photo.name} className="w-100" style={{ aspectRatio: "4 / 3", objectFit: "cover" }} />
              </a>
              {index === coverIndex ? (
                <span className="badge bg-primary position-absolute fw-normal" style={{ top: "6px", left: "6px" }}>{t("reg_photo_cover")}</span>
              ) : (
                <button
                  type="button"
                  className="reg-edit-only d-flex align-items-center justify-content-center position-absolute bg-white border-0 rounded-circle text-warning shadow-sm"
                  style={{ top: "6px", left: "6px", width: "24px", height: "24px", padding: 0 }}
                  title={t("reg_photo_set_cover")}
                  onClick={() => this.setRegPhotoCover(key, index)}
                >
                  <span className="icon text-12">{""}</span>
                </button>
              )}
              <button
                type="button"
                className="reg-edit-only d-flex align-items-center justify-content-center position-absolute bg-white border-0 rounded-circle text-danger shadow-sm"
                style={{ top: "6px", right: "6px", width: "24px", height: "24px", padding: 0 }}
                onClick={() => this.removeRegFile(key, index)}
              >
                <span className="icon text-12">{""}</span>
              </button>
              <div className="p-2">
                <input
                  type="text"
                  className="form-control text-12"
                  value={photo.caption}
                  onChange={(e) => this.setRegPhotoCaption(key, index, e.target.value)}
                  placeholder={t("reg_photo_caption_placeholder")}
                />
              </div>
            </div>
          </div>
        ))}
        {inputId && (
          <div className="col-6 col-md-4 col-xl-3">
            <label
              htmlFor={inputId}
              className="reg-edit-only border rounded-3 d-flex flex-column align-items-center justify-content-center text-secondary text-12 fw-bold pointer h-100 mb-0"
              style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa", minHeight: "120px" }}
            >
              <span className="icon mb-1">{""}</span> {t("reg_add_photo")}
            </label>
          </div>
        )}
      </div>
    );
  };

  // แถวเอกสาร: ติ๊กว่ามี + แนบไฟล์ (ติ๊กแล้วต้องมีไฟล์แนบ)
  renderRegDocumentRow = (key) => {
    const doc = this.state.reg_documents[key] || { checked: false, files: [] };
    const missingFile = doc.checked && doc.files.length === 0;
    return (
      <div key={key} id={"reg-doc-" + key} className={`border rounded-3 p-2 mb-2 d-flex align-items-start gap-2${missingFile ? " border-danger" : ""}`}>
        <input type="checkbox" className="form-check-input mt-1 pointer flex-shrink-0" checked={doc.checked} onChange={() => this.toggleRegDocument(key)} />
        <div className="flex-grow-1 text-12" style={{ minWidth: 0 }}>
          <div className="text-dark">{t("reg_doc_" + key)}</div>
          {doc.files.map((file, index) => (
            <div key={file.url} className="text-muted d-flex align-items-center">
              <span className="icon me-1">{""}</span>
              <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-truncate">{file.name}</a>
              <span className="reg-edit-only icon ms-2 text-danger pointer" onClick={() => this.removeRegDocumentFile(key, index)}>{""}</span>
            </div>
          ))}
          {missingFile && <div className="text-danger">{t("reg_doc_file_required")}</div>}
        </div>
        <label className="btn btn-outline-secondary btn-sm text-12 fw-bold text-nowrap mb-0">
          {t("reg_attach")}
          <input
            type="file"
            multiple
            hidden
            accept="application/pdf,image/*,.doc,.docx,.xls,.xlsx"
            onChange={(e) => {
              this.addRegDocumentFiles(key, e.target.files);
              e.target.value = "";
            }}
          />
        </label>
      </div>
    );
  };

  // --- Modal Form ---
  renderUpdateModal = () => {
    const {
      modal_create, modal_create_closing, uid, data_department, data_machine_group, data_brand, data_model,
      asset_code, department_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, latitude, longitude, location_remark,
      created_by, created_at, updated_by, updated_at,
      reg_document_number, reg_received_date, reg_machine_name, reg_system, reg_reference, reg_machine_status,
      reg_brand, reg_model, reg_no_serial, reg_capacity, reg_width, reg_length, reg_height, reg_weight, reg_weight_unit,
      reg_electric, reg_power_kw, reg_utility, reg_location_department, reg_soi, reg_road, reg_location_photos,
      reg_documents, reg_training_docs, reg_training_levels, reg_training_evaluation, reg_training_evaluation_files,
      reg_other_files, reg_remark, reg_approval_comment, reg_gps_status, reg_show_errors, reg_readonly, registration_status, is_active,
      data_project, data_customer, project_id, customer_id,
    } = this.state;

    if (!modal_create) return null;

    // กทม. ใช้ "เขต/แขวง" จังหวัดอื่นใช้ "อำเภอ/ตำบล"
    const isBangkok = location_province === "กรุงเทพมหานคร";

    const {
      missing, errors,
      latitudeText, longitudeText, latitudeInvalid, longitudeInvalid, latitudeMissing, longitudeMissing,
      coordinatesSwapped, hasCoordinates, documentsComplete,
    } = this.getRegValidation();
    // ช่องบังคับที่ว่างจะขึ้นสีแดงหลังกดบันทึกหรือส่งอนุมัติ
    const isMissing = (key) => reg_show_errors && missing[key];
    const errorSteps = reg_show_errors ? errors.map((error) => error.step) : [];
    const locationPhotoCount = reg_location_photos.filter((photo) => !photo.failed).length;
    const requiredMessage = (label) => <div className="text-danger text-12 mt-1">{t("reg_validate_required")} {label}</div>;

    const departmentLabel = data_department?.find((e) => e.value === department_id)?.label || "";
    const locationDepartment = reg_location_department || department_id;

    const checkedDocuments = Object.values(reg_documents).filter((doc) => doc.checked);

    const stepDocument = Boolean(department_id && reg_received_date && reg_machine_name && reg_system);
    const stepMachine = Boolean(reg_brand && reg_model);
    // รุ่นแสดงเฉพาะของยี่ห้อที่เลือก - ยังไม่เลือกยี่ห้อ (หรือยี่ห้อเก่าที่ไม่อยู่ใน master) จะไม่มีรุ่นให้เลือก
    const selectedBrandUid = data_brand?.find((e) => e.value === reg_brand)?.uid;
    const brandModels = selectedBrandUid ? data_model.filter((e) => e.brand_uid === selectedBrandUid) : [];
    const stepLocation = Boolean(location_address || location_province || hasCoordinates);
    const stepDocs = checkedDocuments.length > 0 && documentsComplete;

    // เว้นระยะด้านบนตอนกด stepper แล้วเลื่อนมาที่หัวข้อ - ให้เห็นเลขหัวข้อเต็ม ไม่ชิดขอบ/ไม่ถูกแถบแจ้งเตือน (sticky) บัง
    const sectionScrollMargin = reg_show_errors && errors.length > 0 ? "76px" : "32px";
    const SectionHeader = ({ num, title, tooltip, note, id }) => (
      <div id={id} className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2 mt-0" style={{ scrollMarginTop: sectionScrollMargin }}>
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-2 text-12 shadow-sm">
            {num}
          </div>
          <h6 className="fw-bold mb-0 text-dark d-flex align-items-center">
            {title}
            {tooltip && <InfoTooltip>{tooltip}</InfoTooltip>}
          </h6>
        </div>
        <div className="text-muted text-12">{note}</div>
      </div>
    );

    const ChecklistItem = ({ done, optional, label }) => (
      <div className={done ? "text-success" : optional ? "text-secondary" : "text-warning"}>
        <span className="icon me-2">{done ? "" : optional ? "" : ""}</span> {label}
      </div>
    );

    return (
      <div
        className={`modal fade show d-block asset-modal-backdrop${modal_create_closing ? " is-closing" : ""}`}
        style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
      >
        {this.renderModalAnimationStyle()}
        <div className={`modal-dialog modal-dialog-centered modal-fullscreen p-2 p-md-4 asset-modal-dialog${modal_create_closing ? " is-closing" : ""}`}>
          <div className="modal-content border-0 rounded-4 shadow bg-light overflow-hidden d-flex flex-column" style={{ maxHeight: "100%" }}>

            {/* Header */}
            <div className="modal-header border-bottom px-4 py-3 bg-white d-flex justify-content-between align-items-center">
              <div>
                <div className="text-primary text-12 mb-1 fw-bold">
                  {t("asset_management")} <span className="text-secondary mx-1">&gt;</span> <span className="text-dark">{reg_readonly ? t("label_asset_detail") : uid ? t("edit_asset") : t("save_new_asset")}</span>
                </div>
                <h4 className="fw-bold mb-1 d-flex align-items-center flex-wrap text-dark">
                  {t("reg_form_title")}
                  {(() => {
                    // รายการใหม่ยังไม่มีสถานะจาก API -> ร่าง ; รายการเดิมแสดงตามสถานะขึ้นทะเบียน (เหมือน badge ในตาราง)
                    const badge = regStatusBadge(uid ? { registration_status, is_active } : { registration_status: "draft" });
                    return <span className={`badge bg-${badge.color}-light text-${badge.color} border fw-normal text-12 ms-2`}>{t("label_status")}: {t(badge.label)}</span>;
                  })()}
                </h4>
                <div className="text-muted text-12">{t("reg_form_subtitle")}</div>
              </div>
              <button
                type="button"
                onClick={() => this.closeModalWithAnimation("modal_create")}
                aria-label="Close"
                className="d-flex align-items-center justify-content-center border-0 rounded-circle flex-shrink-0"
                style={{ width: "32px", height: "32px", backgroundColor: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.18)", color: "#dc3545", fontSize: "16px", cursor: "pointer" }}
              >
                <span className="icon">{""}</span>
              </button>
            </div>

            <div className="modal-body p-2 p-md-4 bg-light overflow-auto">

              {/* แจ้งเตือนเมื่อกดบันทึก/ส่งอนุมัติแล้วข้อมูลไม่ครบ - คลิกเพื่อไปยังช่องแรกที่ผิด */}
              {reg_show_errors && errors.length > 0 && (
                <div
                  className="bg-white rounded-3 mb-3 shadow-sm pointer"
                  style={{ position: "sticky", top: 0, zIndex: 5 }}
                  onClick={() => this.scrollToRegSection(errors[0].id, "center")}
                >
                  <div className="bg-danger-light text-danger border border-danger rounded-3 px-3 py-2 text-12 fw-bold">
                    <span className="icon me-2">{"\uf06a"}</span>{formatText(t("reg_submit_blocked"), { count: errors.length })}
                  </div>
                </div>
              )}

              {/* Stepper */}
              <div className="card border-0 shadow-sm rounded-4 p-2 p-md-4 mb-4 bg-white">
                <div className="d-flex justify-content-between align-items-center position-relative w-100 px-3">
                  <div className="position-absolute top-50 start-0 w-100 bg-light" style={{ height: "2px", zIndex: 0 }}></div>

                  {[
                    { num: 1, id: "reg-section-document", label: t("reg_section_document"), active: stepDocument },
                    { num: 2, id: "reg-section-machine", label: t("reg_section_machine"), active: stepDocument && stepMachine },
                    { num: 3, id: "reg-section-location", label: t("reg_step_location"), active: stepDocument && stepMachine && stepLocation },
                    { num: 4, id: "reg-section-docs", label: t("reg_step_docs"), active: stepDocument && stepMachine && stepLocation && stepDocs },
                    { num: 5, id: "reg-section-approval", label: t("reg_step_approval"), active: false },
                  ].map((step, idx) => (
                    <div key={idx} className="d-flex flex-column align-items-center position-relative bg-white px-2 pointer" style={{ zIndex: 1 }} onClick={() => this.scrollToRegSection(step.id)}>
                      <div className={`wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center fw-bold text-12 mb-2 position-relative ${step.active ? 'bg-primary text-white' : 'bg-light text-secondary border'}`}>
                        {step.num}
                        {errorSteps.includes(step.num) && (
                          <span className="position-absolute bg-danger rounded-circle border border-white" style={{ top: "-3px", right: "-3px", width: "12px", height: "12px" }}></span>
                        )}
                      </div>
                      <div className={`fw-bold text-12 text-center ${step.active ? 'text-dark' : 'text-secondary'}`}>{step.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <fieldset disabled={reg_readonly} className={reg_readonly ? "reg-readonly" : ""}>
              <div className="row g-4">
                {/* Left Column - Main Form */}
                <div className="col-lg-8 col-xl-9">
                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">

                    {/* 1. ข้อมูลเอกสาร */}
                    <SectionHeader id="reg-section-document" num="1" title={t("reg_section_document")} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4" id="reg-field-department">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_owner_department")} <span className="text-danger">*</span></label>
                        <Select
                          className={`form-control text-12${isMissing("department") ? " border-danger" : ""}`}
                          options={data_department}
                          value={department_id}
                          disabled={Boolean(reg_document_number)}
                          onChange={(e)=> this.setState({department_id: e})}
                          placeholder={t("select_department_placeholder")}
                        />
                        {isMissing("department") ? requiredMessage(t("reg_owner_department")) : <div className="text-muted text-12 mt-1">{t("reg_hint_owner_department")}</div>}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_document_number")}</label>
                        <input type="text" className="form-control bg-light text-12" value={reg_document_number} readOnly placeholder={t("reg_auto_generate_on_save")} />
                        <div className="text-muted text-12 mt-1">{t("reg_hint_document_number")}</div>
                      </div>
                      <div className="col-md-4" id="reg-field-received_date">
                        <label className="form-label text-secondary fw-bold text-12">{t("received_date")} <span className="text-danger">*</span></label>
                        <DatePicker type="th" className={`form-control text-12${isMissing("received_date") ? " border-danger" : ""}`} value={reg_received_date} onChange={val => this.setState({ reg_received_date: val })} />
                        {isMissing("received_date") && requiredMessage(t("received_date"))}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_page_count")}</label>
                        <input type="text" className="form-control bg-light text-12" value="" readOnly placeholder="-" />
                        <div className="text-muted text-12 mt-1">{t("reg_hint_page_count")}</div>
                      </div>
                      <div className="col-md-8" id="reg-field-machine_name">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_machine_name")} <span className="text-danger">*</span></label>
                        <input type="text" className={`form-control text-12${isMissing("machine_name") ? " is-invalid" : ""}`} value={reg_machine_name} onChange={e => this.setState({ reg_machine_name: e.target.value })} placeholder={t("reg_placeholder_machine_name")} />
                        {isMissing("machine_name") && requiredMessage(t("reg_machine_name"))}
                      </div>
                      <div className="col-md-4" id="reg-field-system">
                        <label className="form-label text-secondary fw-bold text-12">{t("system")} <span className="text-danger">*</span></label>
                        <Select
                          className={`form-control text-12${isMissing("system") ? " border-danger" : ""}`}
                          options={data_machine_group}
                          value={reg_system}
                          onChange={(e) => this.setState({ reg_system: e })}
                          placeholder={t("reg_select_system")}
                        />
                        {isMissing("system") ? requiredMessage(t("system")) : <div className="text-muted text-12 mt-1">{t("reg_hint_system")}</div>}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_reference")} <span className="fw-normal text-muted">({t("reg_if_any")})</span></label>
                        <input type="text" className="form-control text-12" value={reg_reference} onChange={e => this.setState({ reg_reference: e.target.value })} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_machine_status")}</label>
                        <Select
                          className="form-control text-12"
                          options={REG_MACHINE_STATUSES.map((status) => ({ value: status, label: t("reg_machine_status_" + status) }))}
                          value={reg_machine_status}
                          onChange={(e) => this.setState({ reg_machine_status: e })}
                          default={false}
                        />
                      </div>
                      {/* โครงการ/ลูกค้า (ไม่บังคับ) ซ่อนไว้ก่อน ยังไม่ได้ใช้งาน - เปิดกลับ: เอา d-none ออกจาก 2 ช่องนี้
                          ใบแจ้งงาน ใบสั่งงาน และแผนตรวจสอบ เลือกเครื่องจักรจากลูกค้าและโครงการที่ผูกไว้ */}
                      <div className="col-md-6 d-none">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_project")} <span className="fw-normal text-muted">({t("optional")})</span></label>
                        <Select
                          className="form-control text-12"
                          options={data_project}
                          value={project_id}
                          onChange={(e)=> this.setState({project_id: e})}
                          placeholder={t("placeholder_select_project")}
                        />
                      </div>
                      <div className="col-md-6 d-none">
                        <label className="form-label text-secondary fw-bold text-12">{t("customer")} <span className="fw-normal text-muted">({t("optional")})</span></label>
                        <Select
                          className="form-control text-12"
                          options={data_customer}
                          onSearch={this.searchCustomers}
                          value={customer_id}
                          onChange={(e, i) => {
                            this.pinCustomer(i);
                            this.setState({ customer_id: e });
                          }}
                          placeholder={t("select_customer")}
                        />
                        <div className="text-muted text-12 mt-1">{t("reg_hint_customer_link")}</div>
                      </div>
                    </div>
                  </div>

                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    {/* 2. ข้อมูลเครื่องจักร */}
                    <SectionHeader id="reg-section-machine" num="2" title={t("reg_section_machine")} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4" id="reg-field-brand">
                        <label className="form-label text-secondary fw-bold text-12">1. {t("reg_brand")} <span className="text-danger">*</span></label>
                        <Select
                          className={`form-control text-12${isMissing("brand") ? " border-danger" : ""}`}
                          options={data_brand}
                          value={reg_brand}
                          // valueLabel = ให้ข้อมูลเก่าที่ยี่ห้อไม่อยู่ใน master (เช่น เคยเลือกจากซีรีส์) ยังแสดงชื่อเดิมได้
                          valueLabel={reg_brand}
                          // เปลี่ยนยี่ห้อ -> ล้างรุ่นที่เลือกไว้ เพราะรุ่นผูกกับยี่ห้อ
                          onChange={(e) => this.setState((prev) => ({ reg_brand: e, reg_model: e === prev.reg_brand ? prev.reg_model : "" }))}
                          placeholder={t("reg_select_brand")}
                        />
                        {isMissing("brand") && requiredMessage(t("reg_brand"))}
                      </div>
                      <div className="col-md-4" id="reg-field-model">
                        <label className="form-label text-secondary fw-bold text-12">2. {t("reg_model")} <span className="text-danger">*</span></label>
                        {/* กดไม่ได้จนกว่าจะเลือกยี่ห้อ และถ้ายี่ห้อนั้นยังไม่มีรุ่นใน master ก็ไม่มีอะไรให้เลือก */}
                        <Select
                          className={`form-control text-12${isMissing("model") ? " border-danger" : ""}`}
                          options={brandModels}
                          value={reg_model}
                          valueLabel={reg_model}
                          onChange={(e) => this.setState({ reg_model: e })}
                          disabled={!reg_brand || brandModels.length === 0}
                          placeholder={!reg_brand ? t("reg_select_brand_first") : brandModels.length === 0 ? t("reg_no_models_for_brand") : t("reg_select_model")}
                        />
                        {isMissing("model") && requiredMessage(t("reg_model"))}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">3. {t("label_serial_no")}</label>
                        <input
                          type="text"
                          className={`form-control text-12${reg_no_serial ? " bg-light" : ""}`}
                          value={serial_number}
                          readOnly={reg_no_serial}
                          onChange={e => this.setState({ serial_number: e.target.value })}
                          placeholder={reg_no_serial ? t("reg_hint_serial_use_asset_id") : ""}
                        />
                        <label className="d-flex align-items-center text-12 text-secondary mt-1 pointer">
                          <input type="checkbox" className="form-check-input mt-0 me-2 pointer" checked={reg_no_serial} onChange={this.toggleRegNoSerial} />
                          {t("reg_no_serial")}
                        </label>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_price")} <span className="fw-normal text-muted">— {t("reg_excluding_vat")}</span></label>
                        <div className="d-flex align-items-center gap-2">
                          <input type="number" className="form-control text-12 text-end" value={price} onChange={e => this.setState({ price: e.target.value })} />
                          <span className="text-muted text-12">{t("baht")}</span>
                        </div>
                        <div className="text-muted text-12 mt-1">{t("reg_hint_price")}</div>
                      </div>
                      <div className="col-md-8">
                        <label className="form-label text-secondary fw-bold text-12">4. {t("reg_capacity")}</label>
                        <input type="text" className="form-control text-12" value={reg_capacity} onChange={e => this.setState({ reg_capacity: e.target.value })} />
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">5. {t("reg_heading_general")}</div>
                      <div className="col-6 col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">5.1 {t("reg_width")} <span className="fw-normal text-muted">({t("reg_unit_mm")})</span></label>
                        <input type="number" min="0" className="form-control text-12" value={reg_width} onChange={e => this.setState({ reg_width: e.target.value })} />
                      </div>
                      <div className="col-6 col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_length")} <span className="fw-normal text-muted">({t("reg_unit_mm")})</span></label>
                        <input type="number" min="0" className="form-control text-12" value={reg_length} onChange={e => this.setState({ reg_length: e.target.value })} />
                      </div>
                      <div className="col-6 col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_height")} <span className="fw-normal text-muted">({t("reg_unit_mm")})</span></label>
                        <input type="number" min="0" className="form-control text-12" value={reg_height} onChange={e => this.setState({ reg_height: e.target.value })} />
                      </div>
                      <div className="col-6 col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_weight")}</label>
                        <div className="d-flex align-items-center gap-2">
                          <input type="number" min="0" className="form-control text-12" value={reg_weight} onChange={e => this.setState({ reg_weight: e.target.value })} />
                          <select className="form-select text-12" style={{ width: "90px" }} value={reg_weight_unit} onChange={e => this.setState({ reg_weight_unit: e.target.value })}>
                            <option value="Kg">Kg</option>
                            <option value="Ton">Ton</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">5.2 {t("reg_electric")}</label>
                        <input type="text" className="form-control text-12" value={reg_electric} onChange={e => this.setState({ reg_electric: e.target.value })} placeholder="220 V AC 50 Hz" />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_power")} <span className="fw-normal text-muted">(KW) — {t("optional")}</span></label>
                        <input type="number" min="0" className="form-control text-12" value={reg_power_kw} onChange={e => this.setState({ reg_power_kw: e.target.value })} placeholder="0.5" />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">5.3 {t("reg_utility")}</label>
                        <textarea className="form-control text-12" rows="2" value={reg_utility} onChange={e => this.setState({ reg_utility: e.target.value })} placeholder={t("reg_placeholder_utility")}></textarea>
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">{t("reg_heading_machine_photos")}</div>
                      <div className="col-12">
                        <input
                          type="file"
                          id="reg-machine-photo-upload"
                          multiple
                          accept="image/*"
                          hidden
                          onChange={(e) => {
                            this.addRegPhotos("reg_machine_photos", e.target.files);
                            e.target.value = "";
                          }}
                        />
                        {this.renderRegPhotoGrid("reg_machine_photos", "reg-machine-photo-upload")}
                      </div>
                    </div>
                  </div>

                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    {/* 3. ที่ตั้งของเครื่องจักร */}
                    <SectionHeader id="reg-section-location" num="3" title={t("reg_section_location")} note={t("note_optional_section")} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-8">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_location_department")}</label>
                        <Select
                          className="form-control text-12"
                          options={data_department}
                          value={locationDepartment}
                          onChange={(e)=> this.setState({reg_location_department: e})}
                          placeholder={t("select_department_placeholder")}
                        />
                        <div className="text-muted text-12 mt-1">{t("reg_hint_location_department")}</div>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_id")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{""}</span>
                          <input type="text" className="form-control bg-white text-primary fw-bold text-12" disabled style={{paddingLeft:30}} value={location_running_number} readOnly />
                        </div>
                        <div className="text-muted text-12 mt-1">{t("reg_auto_generate_on_save")}</div>
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_location_name")} <span className="fw-normal text-muted">({t("optional")})</span></label>
                        <input type="text" className="form-control text-12" value={location_name} onChange={e => this.setState({ location_name: e.target.value })} placeholder={t("reg_placeholder_location_name")} />
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">{t("reg_heading_address")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_house_no")}</label>
                        <input type="text" className="form-control text-12" value={location_address} onChange={e => this.setState({ location_address: e.target.value })} placeholder="99/9" />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_soi")}</label>
                        <input type="text" className="form-control text-12" value={reg_soi} onChange={e => this.setState({ reg_soi: e.target.value })} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_road")}</label>
                        <input type="text" className="form-control text-12" value={reg_road} onChange={e => this.setState({ reg_road: e.target.value })} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("province")}</label>
                        <Select
                          className="form-control text-12"
                          options={PROVINCE.map(e => ({ value: e.th, label: e.th }))}
                          value={location_province}
                          onChange={(e) => this.setState({ location_province: e, location_district: "", location_sub_district: "", location_zip_code: "" })}
                          placeholder={t("option_select_province")}
                          defaultLabel={t("option_select_province")}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{isBangkok ? t("reg_district_bangkok") : t("label_district")}</label>
                        <Select
                          className="form-control text-12"
                          options={PROVINCE.find(e => e.th === location_province)?.district?.map(e => ({ value: e.th, label: e.th })) || []}
                          value={location_district}
                          disabled={!location_province}
                          onChange={(e) => this.setState({ location_district: e, location_sub_district: "", location_zip_code: "" })}
                          placeholder={isBangkok ? t("reg_select_district_bangkok") : t("option_select_district")}
                          defaultLabel={isBangkok ? t("reg_select_district_bangkok") : t("option_select_district")}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{isBangkok ? t("reg_sub_district_bangkok") : t("label_sub_district")}</label>
                        <Select
                          className="form-control text-12"
                          options={PROVINCE.find(e => e.th === location_province)?.district?.find(e => e.th === location_district)?.sub_district?.map(e => ({ value: e.th, label: e.th, code: e.code })) || []}
                          value={location_sub_district}
                          disabled={!location_district}
                          onChange={(e, item) => {
                            // อัปเดตทั้งตำบลและรหัสไปรษณีย์พร้อมกัน (zip code มาจาก field `code` ของ option)
                            // NOTE: code ใน th_province.json เป็น number ต้องแปลงเป็น string ก่อน ไม่งั้น backend (zod string) จะ validate ไม่ผ่าน
                            this.setState({
                              location_sub_district: e,
                              location_zip_code: item?.code != null && item?.code !== "" ? String(item.code) : ""
                            });
                          }}
                          placeholder={isBangkok ? t("reg_select_sub_district_bangkok") : t("option_select_sub_district")}
                          defaultLabel={isBangkok ? t("reg_select_sub_district_bangkok") : t("option_select_sub_district")}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("postal_code")}</label>
                        <input type="text" className="form-control text-12" value={location_zip_code} disabled placeholder={t("reg_auto_fill")} />
                      </div>

                      <div id="reg-field-coordinates" className="col-12 text-primary fw-bold text-12 mt-3">{t("reg_heading_coordinates")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_latitude")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{""}</span>
                          <input type="text" inputMode="decimal" className={`form-control text-12${latitudeInvalid || latitudeMissing ? " is-invalid" : ""}`} style={{paddingLeft:30}} value={latitude} onChange={e => this.setState({ latitude: e.target.value })} placeholder="13.722321" />
                        </div>
                        <div className={`text-12 mt-1 ${latitudeInvalid || latitudeMissing ? "text-danger" : "text-muted"}`}>{latitudeInvalid ? t("reg_validate_latitude") : latitudeMissing ? t("reg_validate_coordinates_pair") : t("reg_hint_coordinates")}</div>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_longitude")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{""}</span>
                          <input type="text" inputMode="decimal" className={`form-control text-12${longitudeInvalid || longitudeMissing ? " is-invalid" : ""}`} style={{paddingLeft:30}} value={longitude} onChange={e => this.setState({ longitude: e.target.value })} placeholder="100.581782" />
                        </div>
                        {(longitudeInvalid || longitudeMissing) && <div className="text-12 mt-1 text-danger">{longitudeInvalid ? t("reg_validate_longitude") : t("reg_validate_coordinates_pair")}</div>}
                      </div>
                      <div className="col-md-4 d-flex flex-column gap-2 justify-content-end">
                        <button type="button" className="btn btn-outline-primary w-100 fw-bold text-12 d-flex align-items-center justify-content-center bg-primary-light" onClick={this.useRegCurrentPosition}>
                          <span className="icon me-2">{""}</span> {t("reg_use_current_position")}
                        </button>
                        <button type="button" className="btn btn-outline-primary w-100 fw-bold text-12 d-flex align-items-center justify-content-center" onClick={() => {this.setState({modal_create: false, modal_create_closing: false, modal_map:true, currentPath: hasCoordinates ? {lat: parseFloat(latitudeText), lng: parseFloat(longitudeText)} : null})}}>
                          <span className="icon me-2">{""}</span> {t("btn_pin_location")}
                        </button>
                      </div>
                      <div className="col-12">
                        {coordinatesSwapped && (
                          <div className="bg-warning-light text-warning border border-warning rounded-3 px-3 py-2 mb-2 text-12 d-flex align-items-center justify-content-between gap-2">
                            <span>{t("reg_coordinates_swapped")}</span>
                            <button type="button" className="btn btn-outline-warning btn-sm text-12 fw-bold text-nowrap" onClick={this.swapRegCoordinates}>
                              <span className="icon me-1">{"\uf0ec"}</span> {t("reg_swap")}
                            </button>
                          </div>
                        )}
                        {hasCoordinates ? (
                          <iframe
                            title={t("btn_pin_location")}
                            className="w-100 border rounded-3"
                            style={{ height: "210px" }}
                            loading="lazy"
                            src={`https://maps.google.com/maps?q=${encodeURIComponent(latitudeText + "," + longitudeText)}&z=16&output=embed`}
                          />
                        ) : (
                          <div
                            className="border rounded-3 d-flex align-items-center justify-content-center text-secondary text-12"
                            style={{ height: "210px", borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                          >
                            <span className="icon me-2">{""}</span> {t("reg_map_placeholder")}
                          </div>
                        )}
                        {reg_gps_status && (
                          <div className={`bg-${reg_gps_status.type}-light text-${reg_gps_status.type} border border-${reg_gps_status.type} rounded-3 px-3 py-2 mt-2 text-12`}>{reg_gps_status.text}</div>
                        )}
                      </div>

                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_additional_remark")}</label>
                        <textarea className="form-control text-12" rows="2" value={location_remark} onChange={e => this.setState({ location_remark: e.target.value })} placeholder={t("reg_placeholder_location_remark")}></textarea>
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">
                        {t("reg_heading_location_photos")} <span className="fw-normal text-muted">({t("reg_unlimited")})</span>
                      </div>
                      <div className="col-12">
                        <label
                          htmlFor="reg-location-photo-upload"
                          className="reg-edit-only border rounded-3 p-3 mb-2 text-center pointer d-block"
                          style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                          onDragOver={this.handleCwcDragOver}
                          onDrop={(e) => {
                            e.preventDefault();
                            this.addRegPhotos("reg_location_photos", e.dataTransfer.files);
                          }}
                        >
                          <div className="icon text-secondary mb-1" style={{ fontSize: "20px" }}>{""}</div>
                          <div className="text-secondary text-12 fw-bold">{t("reg_photo_drop_title")}</div>
                          <div className="text-muted text-10 mt-1">{t("reg_photo_drop_hint")}</div>
                        </label>
                        <input
                          type="file"
                          id="reg-location-photo-upload"
                          multiple
                          accept="image/*"
                          hidden
                          onChange={(e) => {
                            this.addRegPhotos("reg_location_photos", e.target.files);
                            e.target.value = "";
                          }}
                        />
                        <div className="d-flex justify-content-between text-muted text-12 mb-2">
                          <span>{locationPhotoCount} {t("reg_unit_photo")}</span>
                          <span><span className="icon text-warning me-1">{""}</span>{t("reg_photo_set_cover")}</span>
                        </div>
                        {this.renderRegPhotoGrid("reg_location_photos")}
                      </div>
                    </div>
                  </div>

                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    {/* 4. เอกสาร การฝึกอบรม และรายงานทดสอบ */}
                    <SectionHeader id="reg-section-docs" num="4" title={t("reg_section_docs")} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-12 text-primary fw-bold text-12">6. {t("reg_heading_manuals")}</div>
                      <div className="col-md-6">{REG_DOCUMENT_KEYS.slice(0, 5).map(this.renderRegDocumentRow)}</div>
                      <div className="col-md-6">{REG_DOCUMENT_KEYS.slice(5).map(this.renderRegDocumentRow)}</div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">7. {t("reg_heading_training")}</div>
                      <div className="col-md-6">
                        <div className="fw-bold text-dark text-12 mb-2">7.1 {t("reg_training_docs")}</div>
                        {REG_TRAINING_COURSES.map((course) => (
                          <label key={course} className="d-flex align-items-center text-12 text-dark mb-2 pointer">
                            <input
                              type="checkbox"
                              className="form-check-input mt-0 me-2 pointer"
                              checked={Boolean(reg_training_docs[course])}
                              onChange={() => this.setState({ reg_training_docs: { ...reg_training_docs, [course]: !reg_training_docs[course] } })}
                            />
                            {t("reg_training_course_" + course)}
                          </label>
                        ))}
                      </div>
                      <div className="col-md-6">
                        <div className="fw-bold text-dark text-12 mb-2">7.2 {t("reg_training_level")}</div>
                        {REG_TRAINING_LEVELS.map((level) => {
                          const current = reg_training_levels[level] || { checked: false, date: "" };
                          return (
                            <div key={level} className="row g-2 align-items-center mb-2">
                              <label className="col-6 d-flex align-items-center text-12 text-dark mb-0 pointer">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-0 me-2 pointer"
                                  checked={current.checked}
                                  onChange={() => this.setState({ reg_training_levels: { ...reg_training_levels, [level]: { checked: !current.checked, date: current.checked ? "" : current.date } } })}
                                />
                                {t("reg_training_level_" + level)}
                              </label>
                              <div className="col-6">
                                <DatePicker
                                  type="th"
                                  className="form-control text-12"
                                  value={current.date}
                                  disabled={!current.checked}
                                  onChange={val => this.setState({ reg_training_levels: { ...reg_training_levels, [level]: { ...current, date: val } } })}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-12">
                        <div id="reg-field-training-evaluation" className="d-flex align-items-center flex-wrap gap-3 text-12">
                          <span className="fw-bold text-dark">7.3 {t("reg_training_evaluation")}</span>
                          {["yes", "no"].map((value) => (
                            <label key={value} className="d-flex align-items-center text-dark mb-0 pointer">
                              <input
                                type="radio"
                                className="form-check-input mt-0 me-2 pointer"
                                name="reg_training_evaluation"
                                checked={reg_training_evaluation === value}
                                onChange={() => this.setState({ reg_training_evaluation: value })}
                              />
                              {t("reg_option_" + value)}
                            </label>
                          ))}
                          {reg_training_evaluation === "yes" && (
                            <label className="btn btn-outline-secondary btn-sm text-12 fw-bold text-nowrap mb-0">
                              {t("reg_attach")}
                              <input
                                type="file"
                                multiple
                                hidden
                                accept="application/pdf,image/*,.doc,.docx,.xls,.xlsx"
                                onChange={(e) => {
                                  this.addRegFiles("reg_training_evaluation_files", e.target.files);
                                  e.target.value = "";
                                }}
                              />
                            </label>
                          )}
                          <span className={reg_training_evaluation === "yes" && reg_training_evaluation_files.length === 0 ? "text-danger" : "text-muted"}>{t("reg_hint_training_evaluation")}</span>
                        </div>
                        {reg_training_evaluation === "yes" && reg_training_evaluation_files.map((file, index) => (
                          <div key={file.url} className="text-muted text-12 d-flex align-items-center mt-1">
                            <span className="icon me-1">{""}</span>
                            <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-truncate">{file.name}</a>
                            <span className="reg-edit-only icon ms-2 text-danger pointer" onClick={() => this.removeRegFile("reg_training_evaluation_files", index)}>{""}</span>
                          </div>
                        ))}
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3">8. {t("reg_heading_inspection")}</div>
                      <div className="col-12">{REG_INSPECTION_KEYS.map(this.renderRegDocumentRow)}</div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3 d-flex align-items-center justify-content-between">
                        <span>{t("reg_heading_other_docs")}</span>
                        <label className="btn btn-outline-primary btn-sm fw-bold mb-0">
                          <span className="icon me-1">{""}</span> {t("reg_add_file")}
                          <input
                            type="file"
                            multiple
                            hidden
                            accept="application/pdf,image/*,.doc,.docx,.xls,.xlsx"
                            onChange={(e) => {
                              this.addRegFiles("reg_other_files", e.target.files);
                              e.target.value = "";
                            }}
                          />
                        </label>
                      </div>
                      <div className="col-12">
                        {reg_other_files.length === 0 && <div className="text-muted text-12">{t("reg_no_other_files")}</div>}
                        {reg_other_files.map((file, index) => (
                          <div key={file.url} className="border rounded-3 p-2 mb-2 d-flex align-items-center gap-2 text-12">
                            <span className="icon text-secondary">{""}</span>
                            <a href={file.url} target="_blank" rel="noopener noreferrer" className="flex-grow-1 text-truncate">{file.name}</a>
                            <span className="reg-edit-only icon text-danger pointer" onClick={() => this.removeRegFile("reg_other_files", index)}>{""}</span>
                          </div>
                        ))}
                      </div>

                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("note")}</label>
                        <textarea className="form-control text-12" rows="2" value={reg_remark} onChange={e => this.setState({ reg_remark: e.target.value })}></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    {/* 5. ตรวจสอบและอนุมัติโดย */}
                    <SectionHeader id="reg-section-approval" num="5" title={t("reg_section_approval")} />
                    <div className="row g-3">
                      {REG_APPROVER_ROLES.map((role) => (
                        <div key={role} className="col-md-4">
                          <div className="card rounded-4 p-3 text-center bg-white h-100" style={{ outline: "1px solid #dddde0" }}>
                            <div className="fw-bold text-dark text-12">{t("reg_approver_" + role)}</div>
                            <div className="text-muted text-12 fst-italic d-flex align-items-center justify-content-center my-2" style={{ height: "56px", borderBottom: "1px dashed #b6c3d3" }}>
                              {t("reg_waiting_signature")}
                            </div>
                            <div className="text-12 text-dark mb-2">-</div>
                            <div><span className="badge bg-secondary-light text-secondary border fw-normal">{t("reg_not_submitted")}</span></div>
                          </div>
                        </div>
                      ))}
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("reg_approver_comment")} <span className="fw-normal text-muted">({t("reg_hint_approver_comment")})</span></label>
                        <textarea className="form-control text-12" rows="2" value={reg_approval_comment} onChange={e => this.setState({ reg_approval_comment: e.target.value })} placeholder={t("reg_placeholder_approver_comment")}></textarea>
                      </div>
                      <div className="col-12 d-flex flex-wrap align-items-center justify-content-end gap-2">
                        <span className="text-muted text-12 me-auto">{t("reg_hint_approver_buttons")}</span>
                        <button type="button" className="btn btn-outline-danger fw-bold text-12 px-3" disabled>
                          <span className="icon me-1">{""}</span> {t("reg_action_reject")}
                        </button>
                        <button type="button" className="btn btn-outline-warning fw-bold text-12 px-3" disabled>
                          <span className="icon me-1">{""}</span> {t("reg_action_revise")}
                        </button>
                        <button type="button" className="btn btn-primary fw-bold text-12 px-3" disabled>
                          <span className="icon me-1">{""}</span> {t("approve")}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Right Column - Sidebar Summary */}
                <div className="col-lg-4 col-xl-3">

                  {/* ASSET ID Box */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <div className="text-secondary fw-bold text-12 mb-2">{t("asset_id_auto_label")}</div>
                    <div className="bg-primary-light text-primary fw-bold text-12 text-center py-2 rounded-3 mb-2 border border-primary">
                      {asset_code || t("hint_asset_code_auto_generate")}
                    </div>
                    <div className="text-muted text-12 text-center">{t("reg_hint_asset_id_format")}</div>
                    <div className="d-flex align-items-center gap-2 mt-3">
                      <div
                        className="rounded-3 d-flex align-items-center justify-content-center text-secondary flex-shrink-0"
                        style={{ width: "64px", height: "64px", border: "1px dashed #9fb4cf" }}
                      >
                        <span className="icon" style={{ fontSize: "24px" }}>{""}</span>
                      </div>
                      <div className="text-muted text-12">{t("reg_hint_qr_code")}</div>
                    </div>
                  </div>

                  {/* สรุปข้อมูล Summary */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      {t("heading_summary")}
                    </h6>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("reg_document_number")}</span>
                      <span className="fw-bold text-dark text-end">{reg_document_number || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("asset")}</span>
                      <span className="fw-bold text-dark text-end">{reg_machine_name || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("reg_brand_model_short")}</span>
                      <span className="fw-bold text-dark text-end">{[reg_brand, reg_model].filter(Boolean).join(" / ") || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("label_serial_no")}</span>
                      <span className="fw-bold text-dark text-end">{serial_number || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("reg_price")} ({t("reg_excluding_vat")})</span>
                      <span className="fw-bold text-dark text-end">{toFixed(price)} {t("baht")}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted text-nowrap">{t("department")}</span>
                      <span className="fw-bold text-dark text-end">{departmentLabel || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap"><span className="icon text-danger me-1">{""}</span> {t("reg_coordinates_short")}</span>
                      <span className="fw-bold text-primary text-end">{hasCoordinates ? `${latitudeText}, ${longitudeText}` : "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-2 mb-2 text-12">
                      <span className="text-muted text-nowrap">{t("reg_heading_location_photos")}</span>
                      <span className="fw-bold text-dark text-end">{locationPhotoCount} {t("reg_unit_photo")}</span>
                    </div>
                  </div>

                  {/* ความครบถ้วน Checklist */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-success border-bottom pb-2 mb-3 d-flex align-items-center">
                      {t("heading_completeness")}
                    </h6>
                    <div className="d-flex flex-column gap-2 text-12">
                      <ChecklistItem done={Boolean(reg_received_date && reg_machine_name)} label={`1. ${t("reg_section_document")}`} />
                      <ChecklistItem done={Boolean(reg_system && reg_brand && reg_model)} label={`2. ${t("reg_checklist_system_brand_model")}`} />
                      <ChecklistItem done={Boolean(department_id)} label={`3. ${t("reg_checklist_owner_department")}`} />
                      <ChecklistItem done={stepLocation} optional label={`4. ${t("reg_checklist_address")} (${t("optional")})`} />
                      <ChecklistItem done={locationPhotoCount > 0} optional label={`5. ${t("reg_checklist_location_photos")} (${t("optional")})`} />
                      <ChecklistItem done={documentsComplete} label={`6. ${t("reg_checklist_attachments")}`} />
                      <ChecklistItem done={false} optional label={`7. ${t("submit_for_approval")}`} />
                    </div>
                  </div>

                  {/* Record & Edit Info */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      {t("reg_heading_history")}
                    </h6>
                    <div className="mb-2 text-12">
                      <div className="fw-bold text-dark">{t("label_record_asset")}</div>
                      <div className="text-muted">{this.formatUserActivity(created_by, created_at)}</div>
                    </div>
                    <div className="text-12">
                      <div className="fw-bold text-dark">{t("label_edit_asset_info")}</div>
                      <div className="text-muted">{this.formatUserActivity(updated_by, updated_at)}</div>
                    </div>
                  </div>

                </div>
              </div>
              </fieldset>
            </div>

            {/* Footer fixed */}
            <div className="modal-footer px-4 py-3 bg-white border-top d-flex justify-content-between align-items-center w-100 mt-auto">
              <div className={`text-warning text-12 fw-bold align-items-center ${reg_readonly ? "d-none" : "d-flex"}`}>
                <span className="icon me-2">{""}</span> {t("reg_footer_note")}
              </div>
              <div className="d-flex flex-wrap gap-2">
                <button type="button" className="btn btn-white border fw-bold px-4 text-secondary bg-white shadow-sm" onClick={() => this.closeModalWithAnimation("modal_create")}>
                  <span className="icon me-1">{""}</span> {t("cancel")}
                </button>
                {/* พิมพ์ FMN-03 ยังไม่มี API รองรับ - ปิดปุ่มไว้ก่อน ส่วนส่งอนุมัติตอนนี้ตรวจความครบถ้วนอย่างเดียว */}
                <button type="button" className="btn btn-white border fw-bold px-4 text-secondary bg-white shadow-sm" disabled>
                  <span className="icon me-1">{""}</span> {t("reg_print_form")}
                </button>
                <button type="button" className={`btn btn-soft-success fw-bold px-4 shadow-sm${reg_readonly ? " d-none" : ""}`} onClick={() => this.CreateUpdate()}>
                  <span className="icon me-2">{""}</span> {t("save_draft")}
                </button>
                <button type="button" className={`btn btn-primary fw-bold px-4 align-items-center shadow-sm ${reg_readonly ? "d-none" : "d-flex"}`} onClick={this.submitRegForApproval}>
                  <span className="icon me-2">{""}</span> {t("submit_for_approval")}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
  render() {
    const {
      modal_map, data, count, summary_count, filter_search, filter_department, filter_status, data_department, currentPath
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("asset_management")}</h3>
                        <div className="text-secondary text-14">{t("subtitle_asset_management_page")}</div>
                    </div>
                </div>

                {/* Top KPI Cards - นับจาก registration_status (ร่าง/รออนุมัติ/รอแก้ไข) ; เปิดใช้งาน = อนุมัติแล้วและ is_active */}
                <div className="row g-3 mb-4">
                    {[
                        { label: t("reg_kpi_total"), value: summary_count.total, color: "dark" },
                        { label: t("draft"), value: summary_count.draft ?? 0, color: "secondary" },
                        { label: t("waiting_approval"), value: summary_count.pending ?? 0, color: "warning" },
                        { label: t("reg_kpi_revise"), value: summary_count.revise ?? 0, color: "danger" },
                        { label: t("active"), value: summary_count.active, color: "success" },
                    ].map((kpi) => (
                        // 5 การ์ด: จอใหญ่เรียงแถวเดียวเท่ากัน ; จอกลาง 3 ต่อแถว ; จอเล็ก 2 ต่อแถว
                        <div key={kpi.label} className="col-xl col-md-4 col-6">
                            <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                                <h4 className={`fw-bold text-${kpi.color} mb-0`}>{fmtInt(kpi.value)}</h4>
                                <div className="text-secondary text-12">{kpi.label}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main White Container & Filters */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative flex-grow-1" style={{ maxWidth: "300px" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5"
                                    style={{ height: "38px", width: "300px", maxWidth: "100%" }}
                                    placeholder={t("reg_search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyUp={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>

                            <Select
                                className="form-control wpx-200"
                                options={data_department}
                                value={filter_department}
                                onChange={(e) => this.setState({ filter_department: e })}
                                placeholder={t("all_departments")}
                                defaultLabel={t("all_departments")}
                            />
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "draft", label: t("draft") },
                                    { value: "pending", label: t("waiting_approval") },
                                    { value: "revise", label: t("reg_kpi_revise") },
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_status")}
                                defaultLabel={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "", filter_department: "", filter_customer: "", filter_vendor_warranty: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>

                        <div className="ms-auto d-flex gap-2">
                            {/* Export ยังไม่มี API รองรับ - ปิดปุ่มไว้ก่อน */}
                            <button className="btn btn-white bg-white border px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center" disabled>
                                <span className="icon me-2 text-14">{"\uf019"}</span> {t("export")}
                            </button>
                            {can("asset.create") && (
                              <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openModalCreate}>
                                  <span className="me-2 text-16">+</span> {t("reg_btn_new")}
                              </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm pb-2">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1200px" }}>
                            <thead>
                                <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                                    <th className="py-3 border-0">{t("reg_document_number")}</th>
                                    <th className="py-3 border-0">{t("asset_id")}</th>
                                    <th className="py-3 border-0">{t("reg_machine_name")}</th>
                                    <th className="py-3 border-0">{t("reg_brand_model_short")}</th>
                                    <th className="py-3 border-0">{t("label_serial_no")}</th>
                                    <th className="py-3 border-0">{t("department")}</th>
                                    <th className="py-3 border-0">{t("reg_column_location")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    {/* ปุ่ม action ปักไว้ขวาสุด (sticky) ตารางกว้างกว่าจอ เลื่อนแล้วยังกดได้ทันที */}
                                    <th className="py-3 border-0 wpx-120 text-center bg-white" style={STICKY_ACTION_STYLE}>{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => {
                                        const brandModel = [item.brand_name, item.model_name].filter(Boolean).join(" / ");
                                        const hasCoordinates = String(item.latitude ?? "").trim() !== "" && String(item.longitude ?? "").trim() !== "";
                                        return (
                                            <tr key={idx} className="border-bottom border-light bg-white">
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.document_number || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="fw-bold text-primary text-12">{item.asset_code || "-"}</span>
                                                </td>
                                                <td>
                                                    <div className="fw-bold text-dark text-12">{item.machine_name || item.part_name || item.part?.name || "-"}</div>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{brandModel || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.serial_number || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.department?.name || item.department_name || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    {hasCoordinates ? (
                                                        <a
                                                            className="text-12 text-success"
                                                            href={`https://www.google.com/maps?q=${encodeURIComponent(item.latitude + "," + item.longitude)}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <span className="icon me-1">{"\uf3c5"}</span>{t("reg_has_coordinates")}
                                                        </a>
                                                    ) : (
                                                        <span className="text-12 text-warning">
                                                            <span className="icon me-1">{"\uf071"}</span>{t("reg_no_coordinates")}
                                                        </span>
                                                    )}
                                                    {item.location_photo_count > 0 && (
                                                        <span className="text-12 text-secondary ms-2">
                                                            <span className="icon me-1">{"\uf03e"}</span>{item.location_photo_count}
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {/* ร่าง/รออนุมัติ/รอแก้ไข แสดงสถานะขึ้นทะเบียนก่อน ; อนุมัติแล้วจึงแสดงเปิด/ปิดใช้งาน */}
                                                    {(() => {
                                                        const badge = regStatusBadge(item);
                                                        return (
                                                            <span className={`badge bg-${badge.color}-light text-${badge.color} rounded-pill px-2 py-1 fw-bold text-12`}>
                                                                ● {t(badge.label)}
                                                            </span>
                                                        );
                                                    })()}
                                                </td>
                                                <td className="rounded-end text-center bg-white" style={STICKY_ACTION_STYLE}>
                                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                                        <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.openModalDetail(item)} />
                                                        {can("asset.update") && (
                                                          <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.openModalUpdate(item)} />
                                                        )}
                                                        {can("asset.delete") && (
                                                          <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item.id || item.uid)} />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer Pagination */}
                    <div className="d-flex justify-content-between align-items-center p-3 text-secondary text-12 bg-white border-top">
                        <div>
                            {t("showing")} 1-{data.length} {t("of")} {fmtInt(count)} {t("items")}
                        </div>
                        <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>
            </div>

            {/* Modal Create/Update */}
            {this.renderUpdateModal()}

            <Modal show={modal_map} onHide={() => this.setState({ modal_map: false, modal_create: true })} size={"fullscreen"}>
                <Modal.Header className="border-0 pb-2" closeButton>
                    <h5 className="fw-bold mb-0">{t("label_pin_from_map")}</h5>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="position-relative" style={{ height: "80vh" }}>
                        <MapsLoader>
                            <GoogleMap
                                mapContainerStyle={{ height: "100%", width: "100%" }}
                                center={
                                    // ถ้ามีการปักหมุดแล้วให้ center เลื่อนตามหมุด แต่ถ้ายังให้ใช้ค่าเริ่มต้น
                                    this.state.currentPath || { lat: 18.9076, lng: 99.046 }
                                }
                                zoom={10}
                                onClick={(e) => {
                                    this.setState({
                                        currentPath: { lat: e.latLng.lat(), lng: e.latLng.lng() },
                                    });
                                }}
                                options={{
                                    disableDefaultUI: true,
                                    clickableIcons: false,
                                    disableDoubleClickZoom: true,
                                    gestureHandling: "greedy",
                                }}
                            >
                                {/* เช็คว่ามีค่า currentPath ใน state หรือยัง ถ้ามีให้แสดง Marker */}
                                {currentPath && <Marker position={currentPath} />}
                            </GoogleMap>
                        </MapsLoader>
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2 border-0 d-flex justify-content-between">
                    <div className="d-flex flex-wrap">
                        <span className="me-2">Latitude: {currentPath?.lat || "-"},</span>
                        <span>Longitude: {currentPath?.lng || "-"}</span>
                    </div>
                    <div className="d-flex">
                        <button
                            className="btn btn-success px-5 me-1"
                            onClick={() => {
                                if (!currentPath) return alert("", "warning", t("warning"), t("validate_map_position_required"));
                                this.setState({ modal_map: false, modal_update: true, modal_create: true, latitude: currentPath.lat.toString(), longitude: currentPath.lng.toString() });
                            }}
                        >
                            {t("save")}
                        </button>
                        <button
                            className="btn btn-outline-success px-5 ms-1"
                            onClick={() => {
                                // ยกเลิกการปักหมุด = กลับไปฟอร์มเดิม (ข้อมูลที่กรอกไว้ยังอยู่ใน state)
                                this.setState({ modal_map: false, modal_create: true });
                            }}
                        >
                            {t("cancel")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
